import { useState } from "react";

// ==========================================
// DATA FROM SUPPLIER DIRECTORY
// ==========================================
const suppliers = [
  // === AC LEVEL 2 CHARGERS ===
  { cat: "L2", name: "Autel Energy", loc: "Shenzhen", price: "$400–$700", power: "Up to 19.2kW (48A)", certs: "✅ UL Listed, FCC, ENERGY STAR", connectors: "J1772, NACS", ocpp: "Yes", branding: "Logo sticker, app branding, network name", moq: "1 (retail available)", lead: "In stock — US warehouse", website: "autelenergy.com", note: "BEST FOR FAST CALIFORNIA DEPLOYMENT. Already at Home Depot & Amazon. UL + ENERGY STAR = CALeVIP eligible. MaxiCharger line. US warehouse = ships in days. Add your vinyl decals on arrival." },
  { cat: "L2", name: "Wallbox (China-made)", loc: "Barcelona/China", price: "$500–$700", power: "Up to 48A / 11.5kW", certs: "✅ UL, ENERGY STAR, assembled USA", connectors: "J1772, NACS", ocpp: "Yes", branding: "Limited — mainly network/app", moq: "Low", lead: "In stock — US", website: "wallbox.com", note: "Pulsar Plus is a top-selling L2 in US. Assembled in USA from global components. Very compact design — easy to vinyl wrap. Strong brand recognition already." },
  { cat: "L2", name: "Zencar", loc: "China", price: "$120–$350", power: "3.5–22kW", certs: "CE, TUV, UL (select)", connectors: "Type 1/2, GB/T, NACS", ocpp: "1.6J / 2.0.1", branding: "Logo engraving, custom colors, vinyl-ready surfaces", moq: "500 (OEM) / 10 (stock)", lead: "4–8 weeks", website: "zencar.net", note: "Very competitive pricing. In-house manufacturing. UL on select models — verify which ones. Great for high-volume L2 deployment. Flat enclosure surfaces are ideal for vinyl branding." },
  { cat: "L2", name: "XTECK", loc: "China", price: "$150–$400", power: "7–22kW", certs: "CE, TUV, UL", connectors: "Type 1/2, NACS options", ocpp: "1.6J", branding: "Logo printing, also sells empty enclosures", moq: "50+", lead: "4–8 weeks", website: "xteckpower.com", note: "Good price/quality ratio. Also sells EMPTY ENCLOSURES if you want to add your own internals. UL certified. Good flat surfaces for vinyl decals and wraps." },
  { cat: "L2", name: "BESEN", loc: "China", price: "$100–$300", power: "7–22kW", certs: "CE, TUV, UL (select)", connectors: "Type 1/2", ocpp: "Available", branding: "Logo + color options, vinyl-ready", moq: "Low (10+)", lead: "4–6 weeks", website: "besenev.com", note: "One of the cheapest quality L2 options. Professional manufacturer also known for cables & connectors. Check UL status per model. Simple clean designs easy to brand." },
  { cat: "L2", name: "IEVPower", loc: "China", price: "$150–$400", power: "7–22kW", certs: "✅ CE, TUV, UKCA, UL, SAA, CB", connectors: "Type 1/2, NACS", ocpp: "Yes", branding: "360° branded experience, logo, colors, app", moq: "1 sample", lead: "Stock + 6–8 wks custom", website: "ievpower.com", note: "Wide certification coverage including UL. Markets itself as 'fully branded experience.' Can start with 1 sample at wholesale. Clean flat housing = perfect for large vinyl decals." },
  { cat: "L2", name: "Electrly", loc: "China", price: "$200–$500", power: "7–22kW", certs: "CE, international", connectors: "Type 1/2, regional options", ocpp: "Yes", branding: "Logo, colors, signage, app white-label", moq: "Negotiable", lead: "6–10 weeks", website: "electrly.com", note: "Well-known white-label brand. Ships to 20+ countries. Includes ADA accessibility options — good for California public stations. Clean modern enclosures." },
  { cat: "L2", name: "EVCOME", loc: "Shanghai", price: "$100–$350", power: "7–22kW", certs: "CE, TUV, CSA, FCC, UL, RoHS", connectors: "Type 1/2, GB/T, NACS", ocpp: "Available", branding: "Professional logo design service, vinyl/print", moq: "Negotiable", lead: "4–8 weeks", website: "evcomecharger.com", note: "Shanghai-based, easy factory visit. 10+ years experience. Offers to DESIGN your logo on the charger. Very flexible and communicative (WhatsApp support). Wide cert coverage." },
  { cat: "L2", name: "BENY (ZJ Beny)", loc: "Zhejiang", price: "$200–$500", power: "3.7–22kW", certs: "✅ CE, UL, TUV, CB", connectors: "Type 1/2, regional", ocpp: "Yes", branding: "Logo, colors, rapid prototypes (2 weeks!)", moq: "Varies", lead: "2 wk prototype / 4–8 wk prod", website: "beny.com", note: "30+ years manufacturing (started in solar). UL certified materials (PC/ABS). Rapid 2-week prototyping. DLB (Dynamic Load Balancing) built-in. Clean surfaces for branding." },

  // === DC FAST CHARGERS ===
  { cat: "DC", name: "BENY (ZJ Beny)", loc: "Zhejiang", price: "$4,200–$9,000", power: "30–240kW", certs: "✅ TUV, UL, CE", connectors: "CCS1, CCS2, CHAdeMO, NACS, GB/T", ocpp: "1.6J", branding: "Logo, colors, screen UI", moq: "1+", lead: "4–8 weeks", website: "beny.com", note: "BEST PRICE/QUALITY for DC fast. 60kW starts at ~$4,200! 240kW dual-gun at ~$7,990. UL certified options. IP55 rated. Floor-mounted with flat panel surfaces ideal for large vinyl graphics. OCPP 1.6J." },
  { cat: "DC", name: "EN+", loc: "Shenzhen", price: "$6,000–$20,000", power: "30–360kW", certs: "✅ CE, UL, TUV, CB", connectors: "CCS1, CCS2, CHAdeMO, NACS", ocpp: "Yes", branding: "Full branding, screen UI, colors", moq: "10+", lead: "6–10 weeks", website: "en-plus.com", note: "Premium Chinese DC manufacturer. Present in 60+ countries. UL certified. Strong English support. Clean modern design. Big flat side panels = excellent for large vinyl wraps with your brand." },
  { cat: "DC", name: "XTECK", loc: "China", price: "$5,000–$16,000", power: "20–240kW", certs: "✅ CE, TUV, UL", connectors: "CCS1, CCS2, CHAdeMO, NACS, GB/T", ocpp: "1.6J", branding: "Logo print, screen, 55\" ad screen option", moq: "50+", lead: "4–8 weeks", website: "xteckpower.com", note: "Wide DC range from 20kW wall-mount to 240kW floor units. Unique 55-inch advertising screen version — great for branded content + revenue from ads. UL certified." },
  { cat: "DC", name: "StarCharge", loc: "Shenzhen", price: "$8,000–$25,000", power: "30–480kW", certs: "CE, TUV, UL (select)", connectors: "CCS1, CCS2, CHAdeMO, NACS", ocpp: "Yes", branding: "Bespoke manufacturing, branding, colors", moq: "10–50", lead: "6–10 weeks", website: "starcharge.com", note: "One of China's LARGEST. 40+ global partners. Goes up to 480kW. Proven track record. Large flat body panels are vinyl-wrap friendly. Higher price = higher build quality." },
  { cat: "DC", name: "Sinexcel", loc: "Shenzhen", price: "$3,000–$15,000 (modules)", power: "30–360kW modules", certs: "✅ CE, UL, TUV", connectors: "Configurable", ocpp: "Integration ready", branding: "You build YOUR enclosure around their modules", moq: "Project-based", lead: "6–12 weeks", website: "en.sinexcel.com", note: "Sells POWER MODULES ONLY. You buy a generic enclosure (from KDM or local), add their charging electronics, apply your vinyl branding. Maximum flexibility. US & Germany subsidiaries. Used by ChargeTronix." },
  { cat: "DC", name: "Hongjiali", loc: "China", price: "$5,000–$20,000", power: "30–360kW", certs: "CE, TUV, SAA, CB, RoHS, ISO", connectors: "CCS1, CCS2, CHAdeMO, GB/T, NACS", ocpp: "Yes", branding: "Logo, colors, screen customization", moq: "Varies", lead: "6–10 weeks", website: "hongjialicharge.com", note: "Transparent about real factory pricing. Warns buyers about uncertified cheap suppliers. Multiple connector options including NACS. Clean enclosure design for branding." },
  { cat: "DC", name: "RUIHUA", loc: "China", price: "$6,000–$22,000", power: "60–350kW", certs: "✅ UL certified (120kW model)", connectors: "CCS1, CCS2, CHAdeMO, GB/T", ocpp: "Yes", branding: "Logo, screen UI, colors", moq: "Varies", lead: "6–10 weeks", website: "rhevcharger.com", note: "120kW model is UL CERTIFIED — important for California. 350kW version has liquid-cooled cables. 98% power conversion efficiency. 10\" LCD touchscreen. Scalable split-system architecture." },
  { cat: "DC", name: "EVCOME", loc: "Shanghai", price: "$5,000–$15,000", power: "20–240kW", certs: "CE, TUV, FCC, UL, RoHS", connectors: "CCS1, CCS2, CHAdeMO, NACS, GB/T", ocpp: "Available", branding: "Logo design service, vinyl print areas", moq: "Negotiable", lead: "4–8 weeks", website: "evcomecharger.com", note: "Same strong company as L2 line. Offers logo design ON the station. Shanghai = easy for factory visits/inspections. Flexible and responsive on WhatsApp. Wide connector support." },
  { cat: "DC", name: "Autel Energy", loc: "Shenzhen", price: "$15,000–$40,000", power: "60–480kW", certs: "✅ UL Listed, FCC", connectors: "CCS1, NACS", ocpp: "Yes", branding: "Network branding, app, screen", moq: "Low", lead: "US warehouse stock", website: "autelenergy.com", note: "Most expensive Chinese option but ALREADY UL LISTED in US. 480kW supercharging pile for highways. Zero import hassle — US warehouse. Premium quality and support. Best for sites needing immediate UL compliance." },
  { cat: "DC", name: "Wissenergy", loc: "China (export)", price: "$5,000–$18,000", power: "30–200kW+", certs: "CE, international", connectors: "All standards available", ocpp: "Yes", branding: "Full OEM/ODM — colors, logos, packaging, vinyl areas", moq: "Negotiable", lead: "6–10 weeks", website: "wissenergy.com", note: "Full white-label service. Will design custom packaging with your brand. Three tiers: OEM, ODM, White-Label. Flat panel enclosures are vinyl-ready. Good for building a complete branded product line." },
  { cat: "DC", name: "Ulandpower", loc: "Fuzhou", price: "$5,000–$15,000", power: "30–200kW+", certs: "CE, various", connectors: "CCS1, CCS2, GB/T", ocpp: "Available", branding: "White-label branding, vinyl-ready", moq: "Negotiable", lead: "6–10 weeks", website: "ulandpower.com", note: "Dedicated white-label company. Clean enclosure designs with large flat surfaces ideal for vinyl decals and wraps. Good sustainability positioning for your brand story." },
];

const ussuppliers = [
  // === DC FAST CHARGER MANUFACTURERS ===
  {
    cat: "DC",
    name: "BTC Power",
    hq: "Irvine, California",
    factory: "Irvine, CA",
    price: "Contact for quote",
    power: "7.2kW (L2) – 360kW (DC Split)",
    certs: "UL Listed, Buy America, NEVI Compliant",
    connectors: "CCS1, CHAdeMO, NACS (J3400)",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: true,
    products: "L2 MaX dual-port, Gen 4 AiO 180kW, Gen 4 Public Split 360kW",
    employees: "500+",
    installed: "25,000+ systems sold",
    founded: "1999 (26 years)",
    special: "791 Co-op approved vendor for federal bidding. Liquid-cooled cables, touchscreen, cord retraction, modular design.",
    note: "YOUR #1 PICK. Local to LA — 40 min drive. Buy America + NEVI compliant, proven at massive scale. Use for ALL federally-funded highway/corridor sites. The government pays 80% of costs, making BTC Power actually cheaper than Chinese chargers on NEVI sites. Gen 4 AiO won industry awards. In-house service plans and ACE training program.",
    website: "btcpower.com",
  },
  {
    cat: "DC",
    name: "SK Signet",
    hq: "Tysons, Virginia",
    factory: "Plano, Texas (136,000 sq ft)",
    price: "Contact for quote",
    power: "200kW – 350kW+ ultra-fast",
    certs: "UL, NEVI Compliant, Buy America",
    connectors: "CCS1, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Ultra-fast DC chargers 200–350kW+, power cabinets",
    employees: "183+ (TX facility)",
    installed: "Claims #1 DC fast charger provider in US",
    founded: "Subsidiary of SK Group ($150B+ conglomerate)",
    special: "$50M invested in Texas factory. 10,000–20,000 units/year capacity. In-house R&D, power module manufacturing, and charger testing with automakers.",
    note: "BEST FOR ULTRA-FAST. Massive production capacity backed by one of South Korea's largest conglomerates. Best for 200kW+ highway charging where you need maximum power. Texas factory = domestic supply chain. Good complement to BTC Power for higher power tiers.",
    website: "sksignet.us",
  },
  {
    cat: "DC",
    name: "Kempower",
    hq: "Durham, North Carolina (HQ: Finland)",
    factory: "Durham, NC (154,000 sq ft, ~300 jobs)",
    price: "Contact for quote",
    power: "50kW – 600kW modular DC",
    certs: "UL, NEVI Compliant, BABA Compliant",
    connectors: "CCS1, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Kempower Satellite system, modular power units + dispensers",
    employees: "~300 (US facility)",
    installed: "Active NEVI wins: TN, VA, KY (PowerUp America partnership)",
    founded: "Finland-based, US factory opened late 2023",
    special: "$40M investment over 5 years. 99% recyclability rate. Modular satellite architecture — 1 power unit feeds multiple charging dispensers. Already shipping US-made chargers. First units shipped to Canada from US factory.",
    note: "BEST MODULAR DESIGN. The satellite system is genius for cost efficiency — one power unit serves multiple dispensers, so you pay for power once and add dispensers cheaply. Ideal for fleet depots, large retail lots, and sites that need to scale over time. Strong NEVI track record in Southeast US.",
    website: "kempower.com/america",
  },
  {
    cat: "DC",
    name: "ABB E-mobility",
    hq: "US operations (HQ: Zurich, Switzerland)",
    factory: "US assembly (multiple locations)",
    price: "Premium tier — contact for quote",
    power: "7.4kW (AC) – 500kW (HPC)",
    certs: "UL, NEVI Compliant, BABA (55%+ US content)",
    connectors: "CCS1, CHAdeMO, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Terra AC wallbox, Terra 54/124/184 DC, Terra 360 (360kW), HPC 500kW",
    employees: "Global Fortune 500 company",
    installed: "1,000,000+ chargers sold worldwide — global #1",
    founded: "1883 (140+ years industrial heritage)",
    special: "ONLY manufacturer that confirmed ability to meet original Buy America timelines without requesting delay. 97% uptime SLA. Full product range from 7kW to 500kW. Industry gold standard for reliability.",
    note: "PREMIUM TIER. Highest quality and reliability in the industry. 1M+ chargers worldwide. Was the only company that didn't ask for a Buy America timeline extension — they were already ready. Best for flagship locations where uptime and brand reputation matter most. 97% uptime SLA helps meet NEVI's 97% requirement automatically. Premium pricing reflects premium quality.",
    website: "new.abb.com/ev-charging",
  },
  {
    cat: "DC",
    name: "Tritium (now Phihong)",
    hq: "Lebanon, Tennessee (HQ: Brisbane, Australia)",
    factory: "Lebanon, TN (30,000 units/yr capacity)",
    price: "Contact for quote",
    power: "50kW (RTM) – 150kW (PKM150)",
    certs: "UL, NEVI Compliant, Buy America",
    connectors: "CCS1, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "PKM150 150kW modular, RTM 50kW compact, power rectifiers",
    employees: "US manufacturing staff in Tennessee",
    installed: "First manufacturer to offer NEVI-compliant product",
    founded: "Australia-based, US factory opened Aug 2022. Acquired by Phihong (Taiwan) in 2024.",
    special: "White House endorsement. Supplied Shell, ChargePoint. NEVI system: 4x PKM150 + 2 power rectifiers = 4 simultaneous EVs. Tennessee factory capacity: 30,000 units/year.",
    note: "⚠️ VERIFY STATUS BEFORE ORDERING. Tritium was the first to offer NEVI-compliant hardware and got White House endorsement, BUT went through financial restructuring and was acquired by Taiwan's Phihong in 2024. Before committing: verify current production status, warranty support, parts availability, and whether BABA compliance is maintained post-acquisition. If stable, their PKM150 is a proven platform.",
    website: "tritiumcharging.com",
  },
  {
    cat: "DC",
    name: "ChargePoint",
    hq: "Campbell, California",
    factory: "US operations (Campbell, CA)",
    price: "Hardware + cloud subscription (CPaaS)",
    power: "L2 up to 19.2kW, DC up to 500kW",
    certs: "UL, NEVI Compliant, Buy America, FedRAMP",
    connectors: "J1772, CCS1, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "CP6000 (L2), Express Plus 500kW (DC), CT4000 series",
    employees: "Public company (NYSE: CHPT)",
    installed: "1,000,000+ places to charge worldwide",
    founded: "2007 (originally Coulomb Technologies)",
    special: "Largest US charging network. $71M+ in NEVI project awards for customers. FedRAMP authorized for government contracts. 120+ individual NEVI site awards. CPaaS subscription model available.",
    note: "BEST NETWORK ECOSYSTEM. ChargePoint is less a hardware OEM and more of a network/software platform. You buy into their ecosystem — their driver app, their cloud dashboard, their roaming network. Great if you want the largest existing driver base. Less ideal if you want VB Charging to be a fully independent brand, since ChargePoint's branding is prominent. Consider for sites where ChargePoint's driver traffic adds value.",
    website: "chargepoint.com",
  },
  {
    cat: "DC",
    name: "FreeWire Technologies",
    hq: "Oakland, California",
    factory: "Oakland, CA",
    price: "Contact for quote (premium for battery)",
    power: "DC Fast (battery-integrated)",
    certs: "UL, Buy America, NEVI Compliant",
    connectors: "CCS1, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Boost Charger (battery-integrated DCFC)",
    employees: "Oakland-based startup",
    installed: "One of first 3 to claim Buy America DCFC compliance",
    founded: "California-based clean energy company",
    special: "Battery storage BUILT INTO the charger. No 480V 3-phase service needed. Eliminates demand charges (a $2K–$10K/month California problem). Was one of only 3 manufacturers originally claiming Buy America DCFC compliance in FHWA filing alongside ChargePoint and Rhombus.",
    note: "SOLVES THE DEMAND CHARGE PROBLEM. California's biggest DCFC profitability killer is demand charges ($2K–$10K/month). FreeWire's battery-integrated Boost Charger eliminates this AND doesn't require 480V service — saving $20K–$80K on transformer upgrades. Perfect for: older buildings, urban locations, sites with limited electrical capacity, and anywhere demand charges would destroy your margins. Oakland, CA = local to you.",
    website: "freewire.com",
  },
  {
    cat: "DC",
    name: "Rhombus Energy Solutions",
    hq: "San Diego, California",
    factory: "San Diego, CA",
    price: "Contact for quote",
    power: "DC bidirectional chargers",
    certs: "UL, Buy America",
    connectors: "CCS1",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Bidirectional DC chargers, V2G (vehicle-to-grid) systems",
    employees: "San Diego-based",
    installed: "One of first 3 to claim Buy America DCFC compliance in FHWA filing",
    founded: "California clean energy company",
    special: "One of only 3 manufacturers that originally claimed full Buy America DCFC compliance in the FHWA Federal Register filing. Specializes in bidirectional charging — your chargers can SEND power back to the grid during peak demand.",
    note: "FUTURE-FORWARD V2G PLAY. Vehicle-to-grid (V2G) is an emerging revenue stream — California utilities are starting programs where EV chargers export stored battery power back to the grid during peak demand, earning you money. Rhombus is already positioned for this. Not your primary supplier today, but could become strategically valuable as V2G regulations mature. Local in San Diego.",
    website: "rhombusenergy.com",
  },

  // === LEVEL 2 AC MANUFACTURERS ===
  {
    cat: "L2",
    name: "BTC Power (L2 MaX)",
    hq: "Irvine, California",
    factory: "Irvine, CA",
    price: "Contact for quote",
    power: "Up to 19.2kW (80A)",
    certs: "UL Listed, Buy America, NEVI Compliant",
    connectors: "J1772, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "L2 MaX single-port, L2 MaX dual-port, wall-mounted",
    employees: "500+",
    installed: "Part of 25,000+ total systems",
    founded: "1999",
    special: "Same manufacturer as your DC fast chargers — single supplier relationship for both L2 and DC. Simplifies procurement, spare parts, service contracts, and training.",
    note: "SIMPLEST PROCUREMENT. If you're already using BTC Power for DC fast chargers (and you should be for NEVI sites), using their L2 line too means one supplier, one service contract, one training program, one spare parts inventory. Local support from Irvine.",
    website: "btcpower.com",
  },
  {
    cat: "L2",
    name: "Wallbox (US Assembly)",
    hq: "USA assembly (HQ: Barcelona, Spain)",
    factory: "US assembly facility",
    price: "$500–$700 (Pulsar Plus)",
    power: "Up to 48A / 11.5kW",
    certs: "UL, ENERGY STAR, Buy America (assembled USA)",
    connectors: "J1772, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Pulsar Plus (L2 48A), Supernova (DC fast), Commander 2 (commercial)",
    employees: "NYSE listed (WBX)",
    installed: "Top-selling L2 charger in US market",
    founded: "2015, Barcelona (US assembly added for Buy America)",
    special: "Pulsar Plus is the best-selling L2 charger in the US. ENERGY STAR certified — critical for CALeVIP incentive eligibility. Compact, sleek design is easy to vinyl wrap. Committed to Buy America compliance during FHWA waiver discussions.",
    note: "BEST L2 FOR CALeVIP INCENTIVES. ENERGY STAR certification is required for some California incentive programs (CALeVIP). Pulsar Plus has it. Top-selling L2 in the US = proven reliability. Compact form factor with smooth surfaces perfect for vinyl branding. Good for hotels, offices, multifamily — any destination charging location.",
    website: "wallbox.com",
  },
  {
    cat: "L2",
    name: "Blink Charging",
    hq: "Miami Beach, Florida",
    factory: "US manufacturing",
    price: "Varies by model + ownership structure",
    power: "L2 up to 19.2kW, DC 30–180kW",
    certs: "UL Listed, NEVI eligible, Buy America",
    connectors: "J1772, CCS1, NACS",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Series 6/7/8 (L2), 30kW–180kW DC fast chargers",
    employees: "Public company (NASDAQ: BLNK)",
    installed: "Global charging network operator",
    founded: "2009",
    special: "UNIQUE: Blink-owned model means ZERO capital outlay. They install at your site, own the equipment, and share revenue with you. Also offers host-owned and hybrid models. Part of FHWA Buy America waiver discussions.",
    note: "ZERO UPFRONT COST OPTION. Their Blink-owned model is unique — they install for free, own the hardware, and share revenue. Could be valuable for testing demand at a location before committing your capital. Also useful for sites where property owners want EV charging but don't want to invest. Once you know a site performs, you can install your own VB Charging branded equipment.",
    website: "blinkcharging.com",
  },
  {
    cat: "L2",
    name: "JuiceBar (Oasis Charging)",
    hq: "USA",
    factory: "US manufactured",
    price: "Contact for quote",
    power: "L2 commercial stations",
    certs: "Buy America compliant (confirmed in Federal Register)",
    connectors: "J1772",
    ocpp: "Yes",
    nevi: true,
    baba: true,
    featured: false,
    products: "Commercial L2 charging stations, Gen 3 JuiceBar",
    employees: "US-based company",
    installed: "Named in FHWA Federal Register as Buy America compliant",
    founded: "US EV charging manufacturer",
    special: "Confirmed Buy America compliant for L2 in the official Federal Register filing by FHWA. One of the named manufacturers that can produce Buy America-compliant AC Level 2 chargers.",
    note: "CONFIRMED IN FEDERAL RECORDS. Named in the FHWA Federal Register as capable of producing Buy America compliant L2 chargers. Worth contacting if you specifically need documented Buy America L2 compliance for government-funded non-highway sites or public agency contracts.",
    website: "juicebar.com",
  },
  {
    cat: "L2",
    name: "EVSE LLC",
    hq: "USA",
    factory: "US manufactured",
    price: "Contact for quote",
    power: "L2 commercial stations",
    certs: "Buy America compliant (confirmed in Federal Register)",
    connectors: "J1772",
    ocpp: "Available",
    nevi: true,
    baba: true,
    featured: false,
    products: "Commercial L2 charging stations",
    employees: "US-based manufacturer",
    installed: "Named in FHWA Federal Register as Buy America compliant",
    founded: "US EV charging manufacturer",
    special: "Listed in the FHWA Federal Register as a manufacturer capable of producing Buy America-compliant AC Level 2 chargers.",
    note: "Another federally-confirmed Buy America L2 manufacturer. Smaller player, but documented compliance can be valuable for government contract requirements where you need to prove domestic sourcing.",
    website: "evsellc.com",
  },
];

// ==========================================
// DATA FROM BUSINESS PLAN
// ==========================================
const phases = [
  {
    id: 1,
    title: "Research & Foundation",
    duration: "Month 1–2",
    color: "#0A6847",
    tasks: [
      {
        task: "Market Analysis — California EV Landscape",
        details: "California leads US EV adoption (~12% of new vehicle sales). The state needs ~1.2 million public/shared chargers by 2030 (CEC estimate). 32 new EV models launching in US in 2026. As of early 2026, there are 78,000+ EV charging stations with 241,000+ ports nationwide.",
        priority: "Critical",
      },
      {
        task: "Define Your Business Model",
        details: "Options: CPO (Charge Point Operator — own & operate stations), Site Host (partner with EVgo/ChargePoint), Reseller/Installer (buy wholesale, install for clients), or White-Label Network (your brand, outsourced hardware). CPO model = highest margin but capital-intensive.",
        priority: "Critical",
      },
      {
        task: "Identify Target Locations in California",
        details: "Best locations: LA metro, Bay Area, San Diego, Sacramento, highway corridors (I-5, I-10, I-101). High-traffic spots: malls, grocery stores, hotels (65% EV-ready parking required for new hotels in 2026), retail centers, gas stations, parking garages.",
        priority: "Critical",
      },
      {
        task: "Study California Regulations & Codes",
        details: "Key laws: AB 1236 & AB 970 (streamlined permits, 5-10 business day approval). 2026 Title 24 Building Code requires EV chargers in new construction. California Electrical Code compliance. ADA Chapter 11B accessibility for public stations. NACS (J3400) connector now accepted alongside J1772.",
        priority: "Critical",
      },
      {
        task: "Map All Available Incentives",
        details: "Federal: 30C tax credit (30%, expires June 30 2026 — ACT FAST). NEVI: CA received $384M. CALeVIP 2.0: up to $100K/connector or 50% of costs for DCFC. Utility programs: PG&E, SCE, SDG&E offer make-ready rebates. Local air district programs (SCAQMD, SJVAPCD).",
        priority: "Critical",
      },
      {
        task: "Create Financial Projections",
        details: "Level 2: $3K–$12K/port installed. DCFC: $80K–$250K+/site. Revenue: L2 ~$0.25/kWh, DCFC ~$0.47/kWh avg. CA electricity: ~$0.20-0.32/kWh commercial. Factor in demand charges (can be $2K-$10K/month for DCFC). Target 3-6 year ROI.",
        priority: "Critical",
      },
    ],
  },
  {
    id: 2,
    title: "Supplier Selection & China Evaluation",
    duration: "Month 2–4",
    color: "#1679AB",
    tasks: [
      {
        task: "Contact US-Based Manufacturers",
        details: "BTC Power (Irvine, CA — local! Buy America compliant, 22K+ systems sold), ChargePoint (Campbell, CA), Wallbox USA (assembled in USA), Blink Charging, FreeWire Technologies. These qualify for NEVI funding and Buy America requirements.",
        priority: "Critical",
      },
      {
        task: "Evaluate Chinese Manufacturers (Cost Savings)",
        details: "Top Chinese suppliers with UL certification: StarCharge (40+ global partners), Sinexcel (subsidiaries in US & Germany), EN+ (60+ countries), Autel Energy (UL listed), XTECK (CE/TUV/UL), Wissenergy (OEM/ODM), EraCharge (TÜV/CE). Chinese DC fast chargers can be 30-50% cheaper than US/EU equivalents.",
        priority: "Critical",
      },
      {
        task: "⚠️ Understand Buy America Restrictions",
        details: "CRITICAL: If you want NEVI federal funding, chargers MUST be US-manufactured. Trump admin proposed raising domestic content from 55% → 100%. Chinese chargers CANNOT qualify for NEVI. However, for PRIVATE installations (no federal funds), Chinese chargers are legal with proper UL certification.",
        priority: "Critical",
      },
      {
        task: "Develop a Dual-Source Strategy",
        details: "RECOMMENDED APPROACH: Use US-made chargers (BTC Power, ChargePoint) for NEVI/federally-funded highway corridor sites. Use Chinese white-label chargers for private commercial sites (malls, hotels, offices) where no federal funding is needed. This maximizes both incentives AND cost savings.",
        priority: "Critical",
      },
      {
        task: "Verify UL & Safety Certifications",
        details: "For US market, Chinese chargers MUST have: UL listing (UL 2594 for L2, UL 2202 for DCFC), FCC certification, ENERGY STAR (for CALeVIP L2 eligibility), NRTL listing. Without UL, chargers cannot be legally installed. Request certificates + verify on UL database. Budget $10K-$50K for testing if not pre-certified.",
        priority: "Critical",
      },
      {
        task: "Request & Compare Quotes (Min. 5 Suppliers)",
        details: "Get quotes from at least 2 US and 3 Chinese manufacturers. Compare: unit price, MOQ (minimum order), lead time, shipping costs, customs duties (currently 25%+ tariff on Chinese goods), warranty, spare parts availability, OCPP compatibility, and after-sales support in the US.",
        priority: "High",
      },
      {
        task: "Evaluate CSMS Software Platforms",
        details: "US-focused platforms: ChargePoint (if using their hardware), AMPECO (CALeVIP compliant, NEVI uptime reporting), ChargeLab (white-label), Monta, EV Connect. Must support OCPP 1.6J+, contactless payment, real-time monitoring, and uptime reporting (97% required for NEVI).",
        priority: "High",
      },
      {
        task: "Order Samples & Factory Audit",
        details: "Before bulk ordering from China: request 1-2 sample units, test charging performance, verify UL markings. Consider a third-party factory audit (SGS, Bureau Veritas) — costs ~$500-$2,000 but protects against quality issues. Test OCPP integration with your chosen software.",
        priority: "High",
      },
    ],
  },
  {
    id: 3,
    title: "Legal & Business Setup",
    duration: "Month 3–5",
    color: "#7C00FE",
    tasks: [
      {
        task: "Register Your Business in California",
        details: "Register LLC or Corporation with CA Secretary of State. Obtain EIN from IRS. Get California Seller's Permit. Register with CA Franchise Tax Board. Consider C-Corp if seeking venture capital. Get a business bank account.",
        priority: "Critical",
      },
      {
        task: "Obtain Required Licenses & Permits",
        details: "CA Contractor's License (C-10 Electrical) if doing your own installations, or partner with licensed electrical contractor. Local business license from city/county. Building permits per AB 1236 streamlined process (5-10 business day approval).",
        priority: "Critical",
      },
      {
        task: "Apply for Federal 30C Tax Credit (DEADLINE: June 30, 2026)",
        details: "The Alternative Fuel Infrastructure Tax Credit provides 30% of installation costs. For commercial: up to $100K per location if labor/location requirements met. EXPIRES June 30, 2026 — this is the #1 urgency item. File via IRS Form 8911. Must be placed in service before deadline.",
        priority: "Critical",
      },
      {
        task: "Apply for CALeVIP / NEVI Funding",
        details: "CALeVIP 2.0 Golden State Priority: up to $100K/connector or 50% of costs for DCFC (150kW+ minimum). NEVI: up to 80% of eligible costs for highway corridor stations. Note: NEVI program was frozen in early 2025, restarted Aug 2025, ongoing legal battles — monitor status closely.",
        priority: "High",
      },
      {
        task: "Set Up Import Logistics (If Buying from China)",
        details: "Customs broker for US import. Current tariffs: 25%+ on Chinese EV charging equipment (Section 301). Calculate: unit price + shipping + tariff + customs fees + UL testing = true landed cost. Even with tariffs, Chinese DCFC can still be 15-30% cheaper for private (non-NEVI) installations.",
        priority: "High",
      },
      {
        task: "Secure Insurance & Liability Coverage",
        details: "General liability ($1M+ recommended), professional liability, commercial property insurance, product liability (especially important for imported equipment), workers' comp if hiring. Some California utilities require proof of insurance before interconnection.",
        priority: "High",
      },
      {
        task: "Draft Site Host Agreements",
        details: "Revenue sharing contracts with property owners. Typical models: fixed monthly rent, % of charging revenue (15-30%), or hybrid. Include: electricity cost allocation, maintenance responsibilities, minimum term (5-10 years), equipment ownership, and termination clauses.",
        priority: "High",
      },
    ],
  },
  {
    id: 4,
    title: "Branding & Customization",
    duration: "Month 4–6",
    color: "#E8751A",
    tasks: [
      {
        task: "Design Your Brand Identity",
        details: "Logo, colors, typography. Your brand appears on stations, app, website, signage. For white-label Chinese units: most offer custom enclosure colors, logo placement, screen UI, LED lighting, and packaging. Budget $2K-$10K for professional branding.",
        priority: "High",
      },
      {
        task: "Customize Station Hardware",
        details: "Chinese white-label process: (1) Define specs — power level, connectors (CCS1 + NACS for US market), screen size. (2) Submit brand guidelines. (3) Approve mockups. (4) Production (4-8 weeks typical). (5) UL verification if any design changes. MOQ usually 10-50 units.",
        priority: "High",
      },
      {
        task: "Deploy Branded Driver App & Portal",
        details: "White-label mobile app (iOS + Android) via ChargeLab, AMPECO, or Monta. Features: station finder, real-time availability, session start/stop, payment, history. Operator portal: remote monitoring, analytics, pricing management, uptime tracking.",
        priority: "High",
      },
      {
        task: "Build Your Website & Online Presence",
        details: "Professional website with live station map, pricing, partnership inquiries. Register on Google Business, Apple Maps, PlugShare. SEO for 'EV charging [city name]'. Social media presence — EV community is active on Reddit, X, and Facebook groups.",
        priority: "Medium",
      },
      {
        task: "Design Station Signage (ADA Compliant)",
        details: "California has strict ADA/Chapter 11B requirements for public EV charging accessibility. Signage must include: your brand, charging speeds, pricing per kWh, QR code for app, accessible route markings. Comply with local municipal signage ordinances.",
        priority: "Medium",
      },
    ],
  },
  {
    id: 5,
    title: "Installation & Launch",
    duration: "Month 5–8",
    color: "#C40C0C",
    tasks: [
      {
        task: "Site Surveys & Electrical Assessment",
        details: "For each location: assess utility service capacity, distance to transformer, panel capacity. DCFC needs 480V 3-phase service (may require new transformer — $20K-$80K from utility). L2 needs 208/240V. Contact PG&E/SCE/SDG&E for interconnection requirements and timelines (can be 3-6 months!).",
        priority: "Critical",
      },
      {
        task: "Submit Permits via Streamlined Process",
        details: "California AB 1236/AB 970: permits must be processed in 5-10 business days. Submit via local jurisdiction's online portal. Include: electrical plans, site layout, ADA compliance. No planning department review required — building official only checks health & safety.",
        priority: "Critical",
      },
      {
        task: "Install Pilot Stations (2-4 sites)",
        details: "Start with a mix: 1-2 Level 2 locations (hotel, office, multifamily) + 1-2 DCFC locations (retail, highway-adjacent). Use US-made chargers for any NEVI-funded sites, Chinese chargers for private sites. Validate full workflow before scaling.",
        priority: "Critical",
      },
      {
        task: "Commission, Test & Certify",
        details: "Test every station: charging speeds match specs, payment processing works (credit card, app, RFID), OCPP communication to your backend, emergency shutoff, weatherproofing (NEMA 3R/4 for outdoor). Document everything for warranty and CALeVIP compliance.",
        priority: "Critical",
      },
      {
        task: "Register on All Discovery Platforms",
        details: "List stations on: PlugShare, Google Maps, Apple Maps, your CSMS roaming network (Hubject/GIREVE). For NEVI sites: register with FHWA's Alternative Fuels Station Locator (AFDC). This is critical — drivers can't use stations they can't find.",
        priority: "High",
      },
      {
        task: "Launch Marketing & PR Campaign",
        details: "Press release to local media, EV blogs (Electrek, InsideEVs, CleanTechnica). Partner with local EV dealerships. Introductory pricing (free charging week, discount first month). Social media launch. Reach out to Uber/Lyft drivers — huge market in CA.",
        priority: "High",
      },
    ],
  },
  {
    id: 6,
    title: "Operations & Scale",
    duration: "Month 8+",
    color: "#3D3B40",
    tasks: [
      {
        task: "Monitor KPIs & Optimize",
        details: "Track: utilization rate (target >15% for profitability), revenue/port/month, uptime % (97%+ for NEVI compliance), customer satisfaction, energy costs, demand charges. Use CSMS dashboard for real-time monitoring. Adjust pricing dynamically by time-of-use.",
        priority: "Critical",
      },
      {
        task: "Manage Demand Charges (Critical for DCFC!)",
        details: "California demand charges can be $2K-$10K/month for DCFC stations. Mitigation strategies: battery energy storage systems (BESS), solar canopies, load management, utility EV rate programs (SCE TOU-EV, PG&E BEV). This can make or break DCFC profitability.",
        priority: "Critical",
      },
      {
        task: "Establish Maintenance Operations",
        details: "Remote diagnostics first (70%+ of issues fixable remotely). Local technician network for hardware repairs. Preventive maintenance schedule. Keep spare parts inventory (especially for Chinese chargers where parts take longer to ship). Target 98%+ uptime.",
        priority: "High",
      },
      {
        task: "Scale to 10-25+ Locations",
        details: "Based on pilot data, expand to proven high-demand locations. Negotiate volume pricing with Chinese suppliers (bulk orders of 20-50 units = significant discounts). Continue applying for new CALeVIP funding rounds and utility rebates as they open.",
        priority: "High",
      },
      {
        task: "Develop Additional Revenue Streams",
        details: "Screen advertising on DCFC stations, fleet charging contracts (delivery vans, rideshare), energy arbitrage with battery storage, demand response programs with utilities, premium subscription plans for frequent chargers, data analytics partnerships.",
        priority: "Medium",
      },
    ],
  },
];

const chinaVsUs = [
  { factor: "Level 2 Unit Price", china: "$300–$2,000", us: "$800–$5,000", verdict: "China 40-60% cheaper" },
  { factor: "DCFC Unit Price (150kW)", china: "$8,000–$35,000", us: "$25,000–$80,000", verdict: "China 50-65% cheaper" },
  { factor: "Shipping to CA", china: "$500–$3,000/unit", us: "Included or minimal", verdict: "US advantage" },
  { factor: "Import Tariff (Section 301)", china: "25%+ of value", us: "None", verdict: "US advantage" },
  { factor: "UL Certification", china: "Some have it, many don't", us: "Standard", verdict: "Verify carefully" },
  { factor: "NEVI Eligibility", china: "❌ NOT eligible", us: "✅ Eligible", verdict: "US required for NEVI" },
  { factor: "CALeVIP Eligibility", china: "✅ If UL + ENERGY STAR", us: "✅ Yes", verdict: "Both possible" },
  { factor: "Lead Time", china: "6-12 weeks + 4-6 wk shipping", us: "2-8 weeks", verdict: "US faster" },
  { factor: "White-Label / Custom", china: "Excellent, low MOQ", us: "Limited, higher MOQ", verdict: "China advantage" },
  { factor: "Warranty & Support", china: "Limited US support", us: "Full US support", verdict: "US advantage" },
  { factor: "Spare Parts Speed", china: "2-6 weeks from China", us: "Days", verdict: "US advantage" },
  { factor: "Overall Landed Cost (DCFC)", china: "~$15K–$55K after tariffs", us: "$25K–$80K", verdict: "China still 20-35% cheaper" },
];

const chineseSuppliers = [
  { name: "StarCharge (万马)", hq: "Shenzhen", products: "AC 7-22kW, DC 30-480kW, Ultra-fast", certs: "CE, TUV, UL (select models)", moq: "10-50 units", whiteLabel: "Yes — full customization", note: "40+ global partners, one of China's largest. Strong R&D. Has international subsidiaries." },
  { name: "Sinexcel", hq: "Shenzhen", products: "DC 30-360kW, power modules", certs: "CE, UL, TUV", moq: "Varies", whiteLabel: "Yes — OEM power modules", note: "US & Germany subsidiaries. Supplies power electronics to ChargeTronix. Strong in DC fast charging modules. 2,800+ employees globally." },
  { name: "EN+ (恩宝)", hq: "Shenzhen", products: "AC 7-22kW, DC 30-360kW", certs: "CE, UL, TUV, CB", moq: "10 units", whiteLabel: "Yes — full branding", note: "Present in 60+ countries. Good English support. Active at international trade shows. Strong export experience." },
  { name: "Autel Energy", hq: "Shenzhen", products: "L2 up to 19.2kW, DC up to 240kW", certs: "UL Listed, FCC, ENERGY STAR", moq: "Low — retail available", whiteLabel: "Limited", note: "Already selling in US retail (Home Depot). UL listed MaxiCharger series. Best option for immediate US deployment with Chinese pricing." },
  { name: "XTECK", hq: "China", products: "L2 7-22kW, DC stations, portable", certs: "CE, TUV, UL", moq: "50 units", whiteLabel: "Yes — OEM/ODM", note: "Full OEM services. Good for custom branded portable and wall-mount L2 chargers. Competitive pricing." },
  { name: "Wissenergy", hq: "China (export focused)", products: "AC & DC full range, cables, accessories", certs: "CE, various international", moq: "Negotiable", whiteLabel: "Yes — full OEM/ODM/White-label", note: "Custom colors, packaging, power levels, connectors. Full design service. Good for building your branded product line from scratch." },
  { name: "EraCharge", hq: "China", products: "AC & DC, NACS compatible", certs: "TÜV, CE certified", moq: "Negotiable", whiteLabel: "Yes — colors, logos, connectors", note: "TÜV/CE certified Type 2 sockets. Developing NACS standard compatibility. Good value for money." },
  { name: "BESEN", hq: "China", products: "AC chargers, cables, connectors", certs: "CE, TUV, UL (select)", moq: "Low", whiteLabel: "Yes", note: "Professional L2 manufacturer. Strong in charging cables and accessories. Good for L2 wall-mount stations." },
];

const usSuppliers = [
  { name: "BTC Power", hq: "Irvine, CA 🏠", products: "L2 up to 80A, DC 30-360kW", certs: "UL, Buy America, NEVI compliant", moq: "Project-based", whiteLabel: "Limited", note: "LOCAL to California! 22K+ systems sold. Gen 4 AiO award-winning. Buy America compliant. Best choice for NEVI-funded projects." },
  { name: "ChargePoint", hq: "Campbell, CA 🏠", products: "L2 + DC up to 500kW", certs: "UL, Buy America options", moq: "Varies", whiteLabel: "Operator platform (your pricing/brand)", note: "Largest US network. ChargePoint as a Service subscription model available. Express Plus 500kW flagship. Excellent software platform." },
  { name: "Wallbox USA", hq: "USA (HQ Barcelona)", products: "L2 Pulsar Plus, DC Supernova", certs: "UL, ENERGY STAR, assembled in USA", moq: "Low", whiteLabel: "Limited", note: "Assembled in USA. Pulsar Plus is top-selling L2. Supernova DC fast charger. Strong residential and commercial line." },
  { name: "Blink Charging", hq: "Miami Beach, FL", products: "L2 + DC fast chargers", certs: "UL Listed", moq: "Project-based", whiteLabel: "Host model (revenue sharing)", note: "Multiple ownership models: host-owned, Blink-owned, hybrid. Good for sites where you want zero upfront cost." },
  { name: "FreeWire Technologies", hq: "Oakland, CA 🏠", products: "DC fast + battery-integrated", certs: "UL, Buy America", moq: "Project-based", whiteLabel: "No", note: "Battery-integrated DCFC — reduces demand charges! Boost Charger doesn't need 480V service. Great for sites with limited electrical capacity." },
];


const sections = [
  {
    id: "overview",
    icon: "📊",
    title: "What is NEVI?",
    content: [
      {
        heading: "Program overview",
        text: "The National Electric Vehicle Infrastructure (NEVI) Formula Program is a $5 billion federal initiative (FY 2022–2026) under the Infrastructure Investment and Jobs Act. It funds the build-out of DC fast charging stations along designated Alternative Fuel Corridors (AFCs) — essentially the US interstate highway system.",
      },
      {
        heading: "California's share",
        text: "$384 million allocated to California over 5 years. Administered jointly by Caltrans and the California Energy Commission (CEC). As of early 2026, California is now in Rounds 3–6 of solicitations, offering ~$370 million total (minus ~$14M admin costs).",
      },
      {
        heading: "What NEVI pays for",
        text: "Up to 80% of eligible project costs including: purchase and installation of EV charging equipment, make-ready electrical infrastructure (panels, conduit, trenching, transformers), network connection and software, operation and maintenance for up to 5 years, traffic control and signage directing drivers to chargers.",
      },
      {
        heading: "Your match",
        text: "You (the applicant) must provide at least 20% of total project costs as your funding match. On a $280K project, that's ~$56K out of pocket — the government covers ~$224K.",
      },
    ],
  },
  {
    id: "technical",
    icon: "⚙️",
    title: "Technical requirements",
    content: [
      {
        heading: "Station configuration (minimum)",
        text: "At least 4 DC fast charging ports per station, capable of simultaneously charging 4 EVs. Each port must deliver minimum 150kW continuous power. Total station output: at least 600kW (4 × 150kW). Voltage range: 250V DC to 920V DC (supports both 400V and 800V/900V vehicle architectures).",
      },
      {
        heading: "Connector standards (2026)",
        text: "CCS Type 1 (SAE J1772 Combo): The legacy federal standard — still required. NACS (J3400): Now mandated by the majority of states including California and Texas. Must accommodate both current and next-gen vehicle platforms. Dual-connector configurations (CCS1 + NACS) are the standard for new NEVI installations in 2026.",
      },
      {
        heading: "Communication protocols",
        text: "OCPP 2.0.1 compliance is mandatory as of 2026 (backward compatible with 1.6J). ISO 15118 support required for Plug & Charge functionality. Chargers must support advanced security, improved diagnostics, and automated authentication.",
      },
      {
        heading: "Payment requirements",
        text: "Per California SB 454 and federal 23 CFR 680: Contactless payment accepting major debit and credit cards — no app or membership required. Must also provide either an automated toll-free phone number OR SMS option for initiating charging sessions and submitting payment. Pricing must be transparently displayed in $/kWh.",
      },
      {
        heading: "Uptime requirement",
        text: "97% uptime per port, measured and reported quarterly via the federal EV-ChART tool (per 23 CFR 680.116(b)). This is measured at the individual port level, not station level. Downtime includes: out of service, communication failure, payment system failure, or connector damage. This is one of the hardest requirements to meet — choose reliable hardware and a CSMS with strong remote diagnostics.",
      },
      {
        heading: "Data reporting",
        text: "Quarterly data reporting required via EV-ChART tool. Data includes: uptime per port, energy dispensed, number of charging sessions, pricing data, maintenance records, and station availability. This data is submitted to FHWA and made publicly available.",
      },
      {
        heading: "Accessibility (ADA)",
        text: "Stations must comply with Americans with Disabilities Act requirements. Accessible parking spaces, reach-range requirements for screens and connectors (max 48 inches high), accessible route from parking to charger, tactile and visual signage. At least one accessible charging space per station.",
      },
    ],
  },
  {
    id: "buyamerica",
    icon: "🇺🇸",
    title: "Buy America requirements",
    content: [
      {
        heading: "What Buy America means",
        text: "Under the Build America, Buy America Act (BABA), all EV chargers funded through NEVI must be manufactured and assembled in the United States. This means Chinese-manufactured chargers CANNOT be used on NEVI-funded sites, regardless of certifications.",
      },
      {
        heading: "Current requirements (2026)",
        text: "Final assembly of all chargers must occur in the US. All steel and iron finishing components must be domestically sourced. At least 55% of the total cost of all components must be manufactured in the US (this threshold may increase — Trump admin proposed 100%). The February 2026 FHWA update further tightened Buy America requirements.",
      },
      {
        heading: "Compliant manufacturers for VB Charging",
        text: "BTC Power (Irvine, CA — your top pick), SK Signet (Plano, TX), Kempower (Durham, NC), ABB E-mobility (US assembly), ChargePoint (Campbell, CA), FreeWire (Oakland, CA), Tritium/Phihong (Lebanon, TN — verify post-acquisition status), Rhombus Energy (San Diego, CA).",
      },
      {
        heading: "What happens if you don't comply",
        text: "Non-compliant equipment = automatic disqualification from NEVI funding. No waivers are currently available for new installations (the original waiver expired for chargers manufactured after July 1, 2024). You lose the 80% federal cost coverage.",
      },
    ],
  },
  {
    id: "location",
    icon: "📍",
    title: "Site location requirements",
    content: [
      {
        heading: "Alternative Fuel Corridors (AFCs)",
        text: "NEVI-funded stations must be located along designated Alternative Fuel Corridors — these follow the interstate highway system and major national highways. In California, this includes I-5, I-10, I-15, I-40, I-80, US-101, and other designated corridors. Use the CEC's interactive NEVI map to identify eligible locations.",
      },
      {
        heading: "Distance from highway",
        text: "Stations must generally be within 1 mile of an interstate or highway exit ramp. If you're planning to apply, make sure your site is well within this limit. Some states allow slightly more distance in rural areas.",
      },
      {
        heading: "Spacing benchmark",
        text: "The updated August 2025 guidance REMOVED the strict 50-mile spacing requirement, but states should still consider it as a planning benchmark. This means there's more flexibility in site placement, but preference goes to filling 'charging deserts' — areas without existing DCFC coverage.",
      },
      {
        heading: "Disadvantaged communities bonus",
        text: "Federal law requires 40% of EV charging infrastructure funding go to low-income, disadvantaged, rural, and tribal communities (Justice40 initiative). If your site is in a designated disadvantaged community, you have a STRONGER application. Check the California EPA's CalEnviroScreen 4.0 tool for community designations.",
      },
      {
        heading: "Beyond AFCs (new in 2025/2026)",
        text: "Once a state certifies its AFC network is 'built out,' it can use remaining NEVI funds for non-AFC locations (rural roads, secondary highways, urban areas). The August 2025 guidance simplified this certification — now only requires a letter with 'reasonable explanation.' This opens up more locations for future rounds.",
      },
      {
        heading: "California's NEVI interactive map",
        text: "The CEC publishes an interactive map showing: eligible Alternative Fuel Corridors, project regions for each solicitation round, existing charging stations, planned NEVI-awarded stations, disadvantaged communities overlay, tribal lands, utility districts, and congressional districts. Visit: energy.ca.gov → Programs → Federal EV Infrastructure Programs → NEVI Map. Map was last updated March 2026.",
      },
    ],
  },
  {
    id: "california",
    icon: "🐻",
    title: "California solicitation rounds",
    content: [
      {
        heading: "How California distributes NEVI funds",
        text: "California releases NEVI funding through competitive Grant Funding Opportunities (GFOs) managed by the CEC. There have been 6 rounds so far. Applications are submitted through the Energy Commission Agreement Management System (ECAMS) portal. Each round has a different geographic focus and funding amount.",
      },
      {
        heading: "Round 1 (GFO-23-601): $30.1M — Light-duty, released Oct 2023",
        text: "First round of California NEVI funding. Focused on light-duty DCFC along initial corridor groups. Awards announced — these stations are now in deployment.",
      },
      {
        heading: "Round 2 (GFO-24-606): $33.4M — Light-duty, released Dec 2024",
        text: "Second round focused on additional light-duty corridor segments. Awards in progress.",
      },
      {
        heading: "Round 3 (GFO-25-602): $79M — Light-duty, released Dec 2025",
        text: "Largest light-duty round. Competitive solicitation for DCFC along major corridors. Pre-application workshop held January 14, 2026. Questions deadline: January 22, 2026. Check CEC website for current status — this round may still be accepting applications or reviewing submissions.",
      },
      {
        heading: "Round 4 (GFO-25-604): $69.5M — Medium/Heavy-Duty, Northern & Central CA",
        text: "Released January 21, 2026. Submission deadline: April 22, 2026. Focused on expanding medium- and heavy-duty (MDHD) EV charging infrastructure. If VB Charging wants to serve trucks and buses, this is relevant. Pre-application workshop held February 4, 2026.",
      },
      {
        heading: "Round 5 (GFO-25-606): $79M — Medium/Heavy-Duty, Southern California",
        text: "Released February 5, 2026. Submission deadline: May 7, 2026. ⚠️ THIS IS YOUR MOST RELEVANT ROUND — Southern California, which includes LA. Focused on MDHD charging. Pre-application workshop held February 25, 2026.",
      },
      {
        heading: "Round 6 (GFO-25-603): Light-duty AFCs",
        text: "Details available on CEC website. Check for eligibility in your target corridors. The NEVI interactive map includes a specific layer for Round 6 eligible Alternative Fuel Corridors.",
      },
      {
        heading: "Future rounds",
        text: "Updated NEVI guidance allows states to release all remaining funds in one solicitation. Some states are consolidating. California may do additional rounds or consolidate remaining funds. Monitor energy.ca.gov/solicitations for new GFOs.",
      },
    ],
  },
  {
    id: "application",
    icon: "📝",
    title: "Application process step by step",
    content: [
      {
        heading: "Step 1: Create your ECAMS account",
        text: "Register at the California Energy Commission Agreement Management System (ECAMS) portal. This is the ONLY way to submit NEVI applications in California. Create your user account well before any deadline — technical issues during registration can cost you days. Follow the CEC's 'User Registration Instructions' and 'Applying for a Solicitation' guides.",
      },
      {
        heading: "Step 2: Identify your target solicitation",
        text: "Visit energy.ca.gov/solicitations and filter for 'Fuels and Transportation' division and 'Federal EV Infrastructure Programs.' Identify which GFO round matches your location and vehicle type (light-duty vs. MDHD). Download the full solicitation manual — it contains ALL requirements, forms, and evaluation criteria.",
      },
      {
        heading: "Step 3: Attend the pre-application workshop",
        text: "CEC holds a pre-application workshop (virtual via Zoom) for each solicitation round. This is where they walk through requirements, eligibility, evaluation criteria, and answer questions. Attendance is NOT mandatory but strongly recommended — you'll learn what evaluators prioritize. Recordings are posted on the GFO webpage afterward.",
      },
      {
        heading: "Step 4: Verify your site eligibility",
        text: "Use the CEC NEVI interactive map to confirm your proposed site is: within 1 mile of an eligible Alternative Fuel Corridor, in the correct project region for the solicitation round, and check if it's in a disadvantaged community (bonus scoring). Verify the site has sufficient electrical capacity or that utility upgrades are feasible within the project timeline.",
      },
      {
        heading: "Step 5: Secure site control",
        text: "You must demonstrate legal site control — either ownership, a signed lease agreement, or a binding letter of intent from the property owner. The lease must cover the full term of the NEVI agreement (typically 5+ years). Include the Right of Way Certification (Attachment 13-B in recent solicitations).",
      },
      {
        heading: "Step 6: Select Buy America compliant hardware",
        text: "Choose your charger manufacturer from the Buy America compliant list. Get a formal quote with: model numbers, power specifications, connector types, UL certification numbers, Buy America compliance documentation, and delivery timeline. Your equipment must meet ALL NEVI technical standards (4 ports, 150kW each, CCS1+NACS, OCPP 2.0.1, contactless payment).",
      },
      {
        heading: "Step 7: Prepare your electrical and site design",
        text: "Hire a licensed electrical engineer to produce: site layout drawings showing charger placement and ADA-compliant parking, single-line electrical diagram, load calculations and utility service requirements, conduit and trenching plan. Contact your utility (PG&E, SCE, or SDG&E) for interconnection requirements — this can take 3–6 months, so start EARLY.",
      },
      {
        heading: "Step 8: Develop your project narrative",
        text: "The project narrative is the core of your application (typically Attachment 1 or 2 in the GFO). It must address: project description and goals, site justification (why this location?), community benefits (especially for disadvantaged communities), construction and commissioning timeline, operations and maintenance plan (how you'll achieve 97% uptime), data reporting plan (EV-ChART compliance), and your team's qualifications.",
      },
      {
        heading: "Step 9: Complete budget forms",
        text: "Detailed budget breakdown showing: hardware costs (with Buy America documentation), installation/construction costs, make-ready infrastructure, software/CSMS costs, signage and ADA compliance, your 20% funding match source. All costs must be reasonable and well-documented. Include quotes from contractors and suppliers.",
      },
      {
        heading: "Step 10: Compile and submit application",
        text: "Assemble all required attachments per the solicitation manual checklist. Typical attachments include: application form, project narrative, station information spreadsheet, budget forms, site control documentation, Right of Way certification, letters of commitment/support, NEVI certification form. Submit through ECAMS before the deadline. Late submissions are NOT accepted.",
      },
      {
        heading: "Step 11: Evaluation and award",
        text: "CEC evaluates applications on a competitive basis. Scoring typically considers: technical merit and feasibility, site suitability and corridor coverage, community benefits (Justice40 / disadvantaged community), project timeline and readiness, cost-effectiveness, team experience and qualifications. Awards are announced publicly. If awarded, you enter a grant agreement with the CEC.",
      },
      {
        heading: "Step 12: Build, commission, and operate",
        text: "After award: finalize utility interconnection, obtain building permits (AB 1236 streamlined: 5–10 business days), install equipment, commission and test all stations, register on PlugShare/Google Maps/AFDC locator, begin quarterly data reporting via EV-ChART, maintain 97% uptime per port.",
      },
    ],
  },
  {
    id: "timeline",
    icon: "📅",
    title: "Realistic timeline",
    content: [
      {
        heading: "Month 1–2: Pre-application preparation",
        text: "Create ECAMS account. Identify target solicitation round. Attend pre-application workshop. Begin site identification using CEC NEVI map. Contact property owners for site control. Contact utility (PG&E/SCE/SDG&E) for interconnection assessment — START THIS IMMEDIATELY, it's the longest lead time item.",
      },
      {
        heading: "Month 2–3: Application development",
        text: "Hire electrical engineer for site design and drawings. Select Buy America compliant hardware manufacturer (BTC Power recommended). Get formal hardware quotes. Develop project narrative. Prepare budget forms. Secure letters of commitment from site hosts and utility.",
      },
      {
        heading: "Month 3–4: Submit application",
        text: "Compile all attachments per solicitation checklist. Internal review of full application package. Submit through ECAMS before deadline. Respond to any CEC questions or requests for clarification.",
      },
      {
        heading: "Month 4–8: Evaluation period",
        text: "CEC reviews and scores applications. Awards announced (timeline varies by round — typically 3–6 months after submission deadline). If awarded, negotiate and execute grant agreement with CEC.",
      },
      {
        heading: "Month 8–14: Construction and installation",
        text: "Finalize utility interconnection and service upgrades. Obtain building permits (5–10 business days in CA). Site construction: trenching, conduit, panels, transformer (if needed). Equipment installation and commissioning. Testing and certification. Register stations on all discovery platforms.",
      },
      {
        heading: "Month 14+: Operations and reporting",
        text: "Begin charging operations. Submit quarterly data reports via EV-ChART. Maintain 97% uptime requirement. Ongoing maintenance and customer support. Operate for minimum term specified in grant agreement.",
      },
    ],
  },
  {
    id: "tips",
    icon: "💡",
    title: "Tips to win your application",
    content: [
      {
        heading: "Choose disadvantaged community sites",
        text: "40% of NEVI funding must go to disadvantaged/low-income/rural/tribal communities (Justice40). Sites in these areas score significantly higher. Use CalEnviroScreen 4.0 to check your site's designation. This is one of the easiest ways to strengthen your application.",
      },
      {
        heading: "Demonstrate readiness",
        text: "Applications with signed site leases, completed electrical assessments, utility interconnection applications already submitted, and hardware on order score higher than speculative proposals. The more 'shovel-ready' your project, the better.",
      },
      {
        heading: "Partner with experienced installers",
        text: "If VB Charging is new to NEVI, partnering with an experienced electrical contractor or project developer who has completed NEVI installations improves your application. Include their credentials and past NEVI project references.",
      },
      {
        heading: "Emphasize uptime capability",
        text: "97% uptime is the make-or-break requirement. Detail your maintenance plan: remote diagnostics capability, local technician response time, spare parts inventory, CSMS monitoring dashboard, preventive maintenance schedule. This is where many operators fail post-award.",
      },
      {
        heading: "Consider medium/heavy-duty (Rounds 4 & 5)",
        text: "California's most recent NEVI rounds (GFO-25-604 and GFO-25-606) focus on MDHD charging. This is a less competitive category than light-duty because fewer companies are positioned for it. If VB Charging can serve trucks, buses, and delivery vans, you face less competition for $148.5M in funding.",
      },
      {
        heading: "Stack with other incentives",
        text: "NEVI can be combined with other programs: utility make-ready rebates (PG&E, SCE, SDG&E), the 30C federal tax credit (expires June 30, 2026 — ACT NOW), local air district programs (SCAQMD, SJVAPCD, BAAQMD), and PACE financing. A well-stacked application shows financial sophistication.",
      },
      {
        heading: "Use the CEC pre-application workshop",
        text: "The workshop Q&A section is where you learn what evaluators actually prioritize beyond the written criteria. Attend live if possible — ask specific questions about your proposed site and configuration. Workshop recordings and Q&A documents are posted on each GFO webpage.",
      },
      {
        heading: "Hire a grants consultant (optional but recommended)",
        text: "Companies like Resound Energy, Qmerit, and the ChargePoint grants team specialize in NEVI applications. They know the scoring rubrics, common mistakes, and how to present your project narrative. Cost: typically $5K–$20K or a percentage of the award. On a $200K+ grant, this is a worthwhile investment.",
      },
    ],
  },
  {
    id: "resources",
    icon: "🔗",
    title: "Key links & contacts",
    content: [
      { heading: "California Energy Commission — NEVI program page", text: "energy.ca.gov/programs-and-topics/programs/federal-ev-infrastructure-programs — Main hub for all California NEVI solicitations, maps, and deployment plans." },
      { heading: "CEC solicitations page", text: "energy.ca.gov/solicitations — All active and upcoming Grant Funding Opportunities (GFOs). Filter by 'Fuels and Transportation' division." },
      { heading: "California NEVI interactive map", text: "energy.ca.gov → Federal EV Infrastructure Programs → NEVI Map — Shows eligible corridors, project regions, existing stations, disadvantaged communities. Last updated March 2026." },
      { heading: "ECAMS application portal", text: "Energy Commission Agreement Management System — Create your account and submit applications here. Follow the 'User Registration Instructions' guide." },
      { heading: "Caltrans NEVI deployment plan", text: "dot.ca.gov → Programs → Sustainability → NEVI — California's annually updated NEVI Deployment Plan (2025 version approved September 2025)." },
      { heading: "Federal NEVI guidance (August 2025 update)", text: "highways.dot.gov/NEVI — FHWA's Interim Final Guidance, updated August 11, 2025. This is the currently effective federal guidance." },
      { heading: "23 CFR 680 — Federal minimum standards", text: "The Code of Federal Regulations governing all NEVI-funded EV charging infrastructure. Covers technical specs, uptime, data reporting, payment, and accessibility requirements." },
      { heading: "EV-ChART data reporting tool", text: "Federal tool for quarterly uptime and performance data reporting. Required for all NEVI-funded stations." },
      { heading: "AFDC station locator", text: "afdc.energy.gov — Alternative Fuels Data Center. Use to identify existing stations and charging gaps along corridors." },
      { heading: "CalEnviroScreen 4.0", text: "oehha.ca.gov/calenviroscreen — Check if your proposed site is in a disadvantaged community (higher scoring for NEVI applications)." },
      { heading: "CEC contact", text: "Fuels and Transportation Division: FTD@energy.ca.gov — For general NEVI program questions." },
      { heading: "Caltrans contact", text: "Director's Office of Sustainability: ZEV@dot.ca.gov — For NEVI deployment plan questions." },
    ],
  },
];

// ==========================================
// SUPPLIER DIRECTORY COMPONENT
// ==========================================
function SupplierDirectory()  {
  const [cat, setCat] = useState("all");
  const [expanded, setExpanded] = useState(null);

  const filtered = cat === "all" ? suppliers : suppliers.filter(s => s.cat === cat);

  return (
    <div style={{ fontFamily: "'Newsreader','Georgia',serif", background: "#FAFAF7", minHeight: "100vh", color: "#1a1a1a" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,400;6..72,600;6..72,700&family=DM+Sans:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .card{padding:16px 20px;border-radius:10px;background:white;border:1px solid #ebe8e0;transition:all .2s;cursor:pointer;margin-bottom:10px}
        .card:hover{border-color:#bbb;box-shadow:0 4px 16px rgba(0,0,0,.06)}
        .card.open{box-shadow:0 6px 24px rgba(0,0,0,.08)}
        .fb{cursor:pointer;padding:8px 16px;border:1.5px solid #e0ddd5;border-radius:8px;background:white;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;color:#555;transition:all .2s}
        .fb:hover{border-color:#aaa}.fb.ac{background:#1a2744;color:white;border-color:#1a2744}
        .fb.green{background:#0A6847;color:white;border-color:#0A6847}
        .fb.red{background:#C41E3A;color:white;border-color:#C41E3A}
        .ul-yes{background:#DCFCE7;color:#166534;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:700;font-family:'DM Sans',sans-serif}
        .ul-no{background:#FEF3C7;color:#92400E;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:700;font-family:'DM Sans',sans-serif}
        .sl{font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#888;margin-bottom:8px}
        .price-tag{font-family:'DM Sans',sans-serif;font-size:16px;font-weight:700;color:#C41E3A}
      `}</style>

      {/* Header */}
      <div style={{ background: "linear-gradient(135deg,#1a2744,#0f3460,#162447)", color: "white", padding: "32px 24px 24px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", opacity: .5, marginBottom: 6 }}>Supplier Directory — California Market</div>
          <h1 style={{ fontSize: "clamp(22px,4.5vw,32px)", fontWeight: 700, lineHeight: 1.2, marginBottom: 10 }}>🇨🇳 Chinese EV Charger Manufacturers</h1>
          <p style={{ fontSize: 14, opacity: .75, lineHeight: 1.5, maxWidth: 640 }}>
            {suppliers.length} suppliers with wholesale prices. All support vinyl decals, logo stickers, and brand wraps on their enclosures. Sorted by what matters: <strong>price, UL certification, and US connector support</strong>.
          </p>
          <div style={{ marginTop: 14, padding: 12, background: "rgba(255,255,255,.1)", borderRadius: 8, fontSize: 13, lineHeight: 1.5 }}>
            <strong>Branding approach:</strong> Buy standard hardware → apply your vinyl wrap / decals / logo stickers → brand your CSMS app & screen UI. No custom molds needed. Faster, cheaper, replaceable.
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: "0 auto", padding: "20px 24px 60px" }}>
        {/* Filters */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 20 }}>
          <button className={`fb ${cat==="all"?"ac":""}`} onClick={()=>setCat("all")}>All ({suppliers.length})</button>
          <button className={`fb ${cat==="L2"?"green":""}`} onClick={()=>setCat("L2")}>⚡ Level 2 AC ({suppliers.filter(s=>s.cat==="L2").length})</button>
          <button className={`fb ${cat==="DC"?"red":""}`} onClick={()=>setCat("DC")}>🔴 DC Fast / Level 3 ({suppliers.filter(s=>s.cat==="DC").length})</button>
        </div>

        {/* UL Warning */}
        <div style={{ padding: 14, borderRadius: 10, background: "#FEF2F2", border: "1.5px solid #FECACA", marginBottom: 20 }}>
          <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#7F1D1D", lineHeight: 1.5 }}>
            <strong>⚠️ For California:</strong> Public EV chargers MUST have UL listing to pass inspection. Look for the <span className="ul-yes">✅ UL</span> badge below. Without it, you'll need to pay $10K–$50K and wait 3–6 months for UL testing before deploying. Suppliers marked "UL (select)" means only some models are certified — always verify the specific model you're ordering.
          </p>
        </div>

        {/* Cards */}
        {filtered.map((s, i) => {
          const isOpen = expanded === i;
          const hasUL = s.certs.includes("✅");
          return (
            <div key={i} className={`card ${isOpen?"open":""}`} style={{ borderLeft: `4px solid ${s.cat==="L2"?"#0A6847":"#C41E3A"}` }} onClick={()=>setExpanded(isOpen?null:i)}>
              {/* Top row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 3 }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 16, fontWeight: 700 }}>{s.name}</span>
                    <span style={{ fontSize: 11, color: "#888", fontFamily: "'DM Sans',sans-serif" }}>{s.loc}</span>
                    {hasUL ? <span className="ul-yes">✅ UL Certified</span> : <span className="ul-no">⚠️ Verify UL</span>}
                    <span style={{ background: s.cat==="L2"?"#DCFCE7":"#FEE2E2", color: s.cat==="L2"?"#166534":"#991B1B", padding: "1px 6px", borderRadius: 3, fontSize: 10, fontWeight: 700, fontFamily: "'DM Sans',sans-serif" }}>{s.cat==="L2"?"Level 2":"DC Fast"}</span>
                  </div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: "#666" }}>{s.power} · {s.connectors}</div>
                </div>
                <div style={{ textAlign: "right", flexShrink: 0 }}>
                  <div className="price-tag">{s.price}</div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 10, color: "#888" }}>per unit FOB</div>
                </div>
              </div>

              {/* Expanded */}
              {isOpen && (
                <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f0ede5" }}>
                  <div style={{ padding: 12, background: "#FAF9F6", borderRadius: 8, marginBottom: 12 }}>
                    <p style={{ fontSize: 13, color: "#444", lineHeight: 1.55 }}>{s.note}</p>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <div>
                      {[["Certifications", s.certs.replace("✅ ","")], ["OCPP", s.ocpp], ["Connectors", s.connectors], ["Website", s.website]].map(([k,v])=>(
                        <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", borderBottom: "1px solid #f5f3ed" }}>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#888" }}>{k}</span>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 500, textAlign: "right", maxWidth: "60%" }}>{v}</span>
                        </div>
                      ))}
                    </div>
                    <div>
                      {[["MOQ", s.moq], ["Lead Time", s.lead], ["Branding", s.branding]].map(([k,v])=>(
                        <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", borderBottom: "1px solid #f5f3ed" }}>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#888" }}>{k}</span>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 500, textAlign: "right", maxWidth: "65%" }}>{v}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {!isOpen && <div style={{ textAlign: "center", marginTop: 8 }}><span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#bbb" }}>▼ Tap for details</span></div>}
            </div>
          );
        })}

        {/* Bottom strategy */}
        <div style={{ marginTop: 24, padding: 20, borderRadius: 12, background: "white", border: "1.5px solid #e0ddd5" }}>
          <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 12 }}>🎯 Top Picks for Your California Business</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 14 }}>
            <div style={{ padding: 14, borderRadius: 8, background: "#F0FDF4", border: "1px solid #BBF7D0" }}>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 700, color: "#166534", marginBottom: 4 }}>FASTEST TO DEPLOY</div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 4 }}>Autel Energy</div>
              <p style={{ fontSize: 12, color: "#555", lineHeight: 1.5 }}>Already UL listed, in US warehouses, at Home Depot. Buy today, install next week, add your vinyl decals. Done.</p>
            </div>
            <div style={{ padding: 14, borderRadius: 8, background: "#FEF2F2", border: "1px solid #FECACA" }}>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 700, color: "#991B1B", marginBottom: 4 }}>BEST VALUE DC FAST</div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 4 }}>BENY — $4,200 for 60kW</div>
              <p style={{ fontSize: 12, color: "#555", lineHeight: 1.5 }}>UL/TUV certified. 60kW DC from $4,200, 240kW from ~$8,000. 30+ years manufacturing. Add vinyl wrap for your brand.</p>
            </div>
            <div style={{ padding: 14, borderRadius: 8, background: "#EFF6FF", border: "1px solid #BFDBFE" }}>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 700, color: "#1E40AF", marginBottom: 4 }}>BEST FOR CUSTOM BRAND NETWORK</div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 4 }}>EN+ — 60+ countries</div>
              <p style={{ fontSize: 12, color: "#555", lineHeight: 1.5 }}>UL certified. Premium build. Strong English support. Big flat panels perfect for full vinyl wraps. Clean modern look.</p>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 16, padding: 16, borderRadius: 10, background: "#FFFBEB", border: "1.5px solid #FDE68A" }}>
          <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 700, color: "#92400E", marginBottom: 6 }}>💡 Vinyl Branding Tip</h3>
          <p style={{ fontSize: 13, color: "#78350F", lineHeight: 1.55 }}>
            For branding, you don't need the manufacturer to do it. Order plain/standard color units, then hire a local California vinyl wrap shop to apply your branded decals. Cost: $50–$200 per station for professional vinyl application. This gives you maximum flexibility — change your branding anytime without reordering hardware. For the touchscreen UI and driver app, use your CSMS platform (AMPECO, ChargeLab, Monta) for software-level branding.
          </p>
        </div>
      </div>
    </div>
  );
}

// ==========================================
// BUSINESS PLAN COMPONENT
// ==========================================
function EVBusinessPlan()  {
  const [activePhase, setActivePhase] = useState(0);
  const [activeTab, setActiveTab] = useState("plan");
  const [taskStatuses, setTaskStatuses] = useState({});

  const toggleTask = (phaseIdx, taskIdx) => {
    const key = `${phaseIdx}-${taskIdx}`;
    setTaskStatuses((prev) => ({ ...prev, [key]: prev[key] === "done" ? "todo" : "done" }));
  };

  const getCompletionCount = (phaseIdx) => {
    return phases[phaseIdx].tasks.filter((_, tIdx) => taskStatuses[`${phaseIdx}-${tIdx}`] === "done").length;
  };

  const totalTasks = phases.reduce((a, p) => a + p.tasks.length, 0);
  const totalDone = Object.values(taskStatuses).filter((v) => v === "done").length;

  const Badge = ({ p }) => (
    <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: 4, fontSize: 11, fontWeight: 600, fontFamily: "'DM Sans',sans-serif",
      background: p === "Critical" ? "#FEE2E2" : p === "High" ? "#FEF3C7" : "#DBEAFE",
      color: p === "Critical" ? "#991B1B" : p === "High" ? "#92400E" : "#1E40AF",
    }}>{p}</span>
  );

  return (
    <div style={{ fontFamily: "'Newsreader','Georgia',serif", background: "#FAFAF7", minHeight: "100vh", color: "#1a1a1a" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,300;6..72,400;6..72,600;6..72,700&family=DM+Sans:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .tab-btn{cursor:pointer;padding:10px 16px;border:none;background:none;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;color:#888;border-bottom:2px solid transparent;transition:all .2s;white-space:nowrap}
        .tab-btn:hover{color:#1a1a1a}.tab-btn.active{color:#0A6847;border-bottom-color:#0A6847}
        .phase-btn{cursor:pointer;padding:12px 14px;border:1.5px solid #e0ddd5;border-radius:10px;background:white;text-align:left;transition:all .25s;width:100%}
        .phase-btn:hover{border-color:#bbb;transform:translateY(-1px);box-shadow:0 4px 12px rgba(0,0,0,.06)}
        .phase-btn.active{border-color:var(--pc);background:color-mix(in srgb,var(--pc) 5%,white);box-shadow:0 4px 16px rgba(0,0,0,.08)}
        .task-row{padding:14px 16px;border-radius:8px;background:white;border:1px solid #ebe8e0;margin-bottom:8px;cursor:pointer;transition:all .2s}
        .task-row:hover{border-color:#ccc;box-shadow:0 2px 8px rgba(0,0,0,.04)}
        .task-row.done{opacity:.5}.task-row.done .tt{text-decoration:line-through}
        .chk{width:20px;height:20px;border-radius:50%;border:2px solid #ccc;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .2s}
        .chk.done{background:#0A6847;border-color:#0A6847}
        .sc{padding:14px;border-radius:10px;background:white;border:1px solid #ebe8e0;transition:all .2s}
        .sc:hover{border-color:#bbb;box-shadow:0 4px 16px rgba(0,0,0,.06)}
        .sl{font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#888;margin-bottom:12px}
        .pb{height:6px;background:#e8e5dd;border-radius:3px;overflow:hidden}
        .pf{height:100%;border-radius:3px;transition:width .4s ease}
        .warn-box{padding:16px 20px;border-radius:10px;border:1.5px solid #FDE68A;background:#FFFBEB}
        .crit-box{padding:16px 20px;border-radius:10px;border:1.5px solid #FECACA;background:#FEF2F2}
      `}</style>

      {/* Header */}
      <div style={{ background: "linear-gradient(135deg, #1a2744 0%, #0f3460 50%, #162447 100%)", color: "white", padding: "40px 24px 32px" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 13, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", opacity: .6 }}>Business Strategy</span>
            <span style={{ background: "#E8751A", color: "white", padding: "2px 10px", borderRadius: 4, fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>CALIFORNIA 🇺🇸</span>
          </div>
          <h1 style={{ fontSize: "clamp(24px,5vw,36px)", fontWeight: 700, lineHeight: 1.15, marginBottom: 10 }}>EV Charging Station<br/>Supplier Business Plan</h1>
          <p style={{ fontSize: 15, opacity: .75, lineHeight: 1.5, maxWidth: 640 }}>
            Complete roadmap for Level 2 & Level 3 (DCFC) personalized charging network in California — including Chinese manufacturer evaluation, Buy America strategy, and step-by-step action plan.
          </p>
          <div style={{ marginTop: 18, display: "flex", gap: 24, flexWrap: "wrap", alignItems: "center" }}>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13 }}>
              <span style={{ opacity: .6 }}>Progress: </span><span style={{ fontWeight: 700 }}>{totalDone}/{totalTasks} tasks</span>
            </div>
            <div style={{ flex: "1 1 200px", maxWidth: 300 }}>
              <div className="pb" style={{ background: "rgba(255,255,255,.15)" }}>
                <div className="pf" style={{ width: `${(totalDone / totalTasks) * 100}%`, background: "#7CF5A5" }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ borderBottom: "1px solid #e0ddd5", background: "white", position: "sticky", top: 0, zIndex: 10 }}>
        <div style={{ maxWidth: 960, margin: "0 auto", display: "flex", gap: 2, padding: "0 24px", overflowX: "auto" }}>
          {[["plan","📋 Action Plan"],["china","🇨🇳 China vs US"],["suppliers","🏭 All Suppliers"],["costs","💰 Costs"],["incentives","🏛️ CA Incentives"]].map(([k,l])=>(
            <button key={k} className={`tab-btn ${activeTab===k?"active":""}`} onClick={()=>setActiveTab(k)}>{l}</button>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 960, margin: "0 auto", padding: "24px 24px 60px" }}>

        {/* ============ ACTION PLAN ============ */}
        {activeTab === "plan" && (
          <div style={{ display: "grid", gridTemplateColumns: "minmax(0,260px) minmax(0,1fr)", gap: 24 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div className="sl">Phases</div>
              {phases.map((p, i) => {
                const d = getCompletionCount(i), t = p.tasks.length;
                return (
                  <button key={p.id} className={`phase-btn ${activePhase===i?"active":""}`} style={{"--pc":p.color}} onClick={()=>setActivePhase(i)}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: p.color, flexShrink: 0 }} />
                      <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 600 }}>{p.title}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginLeft: 18 }}>
                      <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#888" }}>{p.duration}</span>
                      <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: d===t?"#0A6847":"#888", fontWeight: d===t?700:400 }}>{d}/{t}</span>
                    </div>
                  </button>
                );
              })}
            </div>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                <div style={{ width: 4, height: 28, borderRadius: 2, background: phases[activePhase].color }} />
                <div>
                  <h2 style={{ fontSize: 22, fontWeight: 700 }}>{phases[activePhase].title}</h2>
                  <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#888" }}>{phases[activePhase].duration}</span>
                </div>
              </div>
              {phases[activePhase].tasks.map((task, tIdx) => {
                const key = `${activePhase}-${tIdx}`, isDone = taskStatuses[key]==="done";
                return (
                  <div key={tIdx} className={`task-row ${isDone?"done":""}`} onClick={()=>toggleTask(activePhase,tIdx)}>
                    <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                      <div className={`chk ${isDone?"done":""}`} style={{ marginTop: 2 }}>
                        {isDone && <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 6L5 8.5L9.5 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}>
                          <span className="tt" style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 600 }}>{task.task}</span>
                          <Badge p={task.priority} />
                        </div>
                        <p style={{ fontSize: 13, lineHeight: 1.55, color: "#555" }}>{task.details}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ============ CHINA vs US ============ */}
        {activeTab === "china" && (
          <div>
            <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 6 }}>China vs. US Manufacturers: Full Comparison</h2>
            <p style={{ fontSize: 15, color: "#666", marginBottom: 20, lineHeight: 1.5 }}>
              You're right that Chinese chargers are significantly cheaper. But the real question is: can you actually use them in California? Here's the complete picture.
            </p>

            <div className="crit-box" style={{ marginBottom: 20 }}>
              <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, color: "#991B1B", marginBottom: 6 }}>🚨 Critical: Buy America Requirements</h3>
              <p style={{ fontSize: 13, color: "#7F1D1D", lineHeight: 1.55 }}>
                The Trump administration proposed raising the domestic content requirement from 55% to 100% for NEVI-funded EV chargers. If you want any federal funding (NEVI, which covers up to 80% of costs), your chargers MUST be US-manufactured. Chinese chargers are completely ineligible for NEVI. However, for privately-funded installations (malls, hotels, offices where you're not using federal money), Chinese chargers with proper UL certification are completely legal.
              </p>
            </div>

            <div className="warn-box" style={{ marginBottom: 24 }}>
              <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, color: "#92400E", marginBottom: 6 }}>💡 Recommended: Dual-Source Strategy</h3>
              <p style={{ fontSize: 13, color: "#78350F", lineHeight: 1.55 }}>
                <strong>Use US-made chargers</strong> (BTC Power, ChargePoint) for NEVI-funded highway corridor sites — get 80% of costs covered by the government. <strong>Use Chinese white-label chargers</strong> for private commercial sites (malls, hotels, offices, parking garages) where you keep full ownership and don't need federal funds. This approach maximizes both incentive capture AND cost savings.
              </p>
            </div>

            <div className="sl">Side-by-Side Comparison</div>
            <div style={{ overflowX: "auto", marginBottom: 32 }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "'DM Sans',sans-serif", fontSize: 13 }}>
                <thead>
                  <tr style={{ borderBottom: "2px solid #e0ddd5" }}>
                    <th style={{ textAlign: "left", padding: "10px 12px", fontWeight: 600 }}>Factor</th>
                    <th style={{ textAlign: "left", padding: "10px 12px", fontWeight: 600, color: "#C40C0C" }}>🇨🇳 Chinese</th>
                    <th style={{ textAlign: "left", padding: "10px 12px", fontWeight: 600, color: "#0A6847" }}>🇺🇸 US-Made</th>
                    <th style={{ textAlign: "left", padding: "10px 12px", fontWeight: 600 }}>Verdict</th>
                  </tr>
                </thead>
                <tbody>
                  {chinaVsUs.map((r, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f0ede5", background: i % 2 === 0 ? "white" : "#FAF9F6" }}>
                      <td style={{ padding: "10px 12px", fontWeight: 600 }}>{r.factor}</td>
                      <td style={{ padding: "10px 12px" }}>{r.china}</td>
                      <td style={{ padding: "10px 12px" }}>{r.us}</td>
                      <td style={{ padding: "10px 12px", fontWeight: 600, fontSize: 12 }}>{r.verdict}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="sl">🇨🇳 Top Chinese Suppliers for US Market</div>
            <p style={{ fontSize: 13, color: "#888", marginBottom: 16 }}>These manufacturers have international certifications and export experience. Always verify UL listing independently before purchasing.</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12, marginBottom: 32 }}>
              {chineseSuppliers.map((s, i) => (
                <div key={i} className="sc" style={{ borderLeft: "3px solid #C40C0C" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700 }}>{s.name}</span>
                    <span style={{ fontSize: 11, color: "#888" }}>{s.hq}</span>
                  </div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 600, color: "#C40C0C", marginBottom: 2 }}>{s.products}</div>
                  <div style={{ fontSize: 11, color: "#555", marginBottom: 4 }}>
                    <strong>Certs:</strong> {s.certs} · <strong>MOQ:</strong> {s.moq} · <strong>White-label:</strong> {s.whiteLabel}
                  </div>
                  <p style={{ fontSize: 12, color: "#666", lineHeight: 1.4 }}>{s.note}</p>
                </div>
              ))}
            </div>

            <div className="sl">🇺🇸 US-Based Manufacturers (NEVI Eligible)</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 12 }}>
              {usSuppliers.map((s, i) => (
                <div key={i} className="sc" style={{ borderLeft: "3px solid #0A6847" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700 }}>{s.name}</span>
                    <span style={{ fontSize: 11, color: "#888" }}>{s.hq}</span>
                  </div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 600, color: "#0A6847", marginBottom: 2 }}>{s.products}</div>
                  <div style={{ fontSize: 11, color: "#555", marginBottom: 4 }}>
                    <strong>Certs:</strong> {s.certs} · <strong>MOQ:</strong> {s.moq} · <strong>White-label:</strong> {s.whiteLabel}
                  </div>
                  <p style={{ fontSize: 12, color: "#666", lineHeight: 1.4 }}>{s.note}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ============ ALL SUPPLIERS ============ */}
        {activeTab === "suppliers" && (
          <div>
            <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 6 }}>Complete Supplier Directory</h2>
            <p style={{ fontSize: 15, color: "#666", marginBottom: 24, lineHeight: 1.5 }}>
              All hardware manufacturers, white-label partners, and software platforms — organized by category.
            </p>

            <div className="sl">💻 Charging Management Software (CSMS)</div>
            <p style={{ fontSize: 13, color: "#888", marginBottom: 12 }}>Essential for managing stations, payments, and compliance. OCPP-compatible, hardware-agnostic platforms.</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 12, marginBottom: 28 }}>
              {[
                { n: "AMPECO", l: "Bulgaria/Global", d: "CALeVIP & NEVI compliant. Best for regulatory compliance. 65+ markets." },
                { n: "ChargeLab", l: "Canada", d: "Affordable white-label app+dashboard. Hardware agnostic. Great for startups." },
                { n: "Monta", l: "Denmark", d: "Popular in US & Europe. Easy setup. Strong roaming network. Flexible billing." },
                { n: "EV Connect", l: "USA", d: "US-focused. Good utility program integration. OCPP compliant." },
                { n: "ChargePoint Cloud", l: "USA", d: "Best if using ChargePoint hardware. Largest network. Premium pricing." },
              ].map((s, i) => (
                <div key={i} className="sc" style={{ borderLeft: "3px solid #7C00FE" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700 }}>{s.n}</span>
                    <span style={{ fontSize: 11, color: "#888" }}>{s.l}</span>
                  </div>
                  <p style={{ fontSize: 12, color: "#666", lineHeight: 1.4 }}>{s.d}</p>
                </div>
              ))}
            </div>

            <div className="sl">🏷️ White-Label / Personalization Partners</div>
            <p style={{ fontSize: 13, color: "#888", marginBottom: 12 }}>Put YOUR brand on chargers — custom colors, logos, screens, and packaging.</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 12 }}>
              {[
                { n: "ChargeTronix", l: "USA", d: "AC+DC white-label. Sinexcel power electronics. US engineering. Custom UI, RFID, OCPP. Apex series 30-480kW." },
                { n: "Electrly", l: "Global", d: "Custom logos, exterior design. Competitive pricing. Bulk discounts. Deployment planning included." },
                { n: "IoTecha", l: "USA", d: "Advanced L2 white-label with ISO 15118 Plug&Charge. Full SDK for software customization." },
                { n: "Wissenergy", l: "China (export)", d: "Full OEM/ODM/White-label. Custom everything. International certifications. Design-to-delivery service." },
                { n: "Wavenetic", l: "Slovenia (EU)", d: "EU-manufactured. Full white-label hardware + cloud platform. Vandal-proof stainless steel." },
              ].map((s, i) => (
                <div key={i} className="sc" style={{ borderLeft: "3px solid #E8751A" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700 }}>{s.n}</span>
                    <span style={{ fontSize: 11, color: "#888" }}>{s.l}</span>
                  </div>
                  <p style={{ fontSize: 12, color: "#666", lineHeight: 1.4 }}>{s.d}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ============ COSTS ============ */}
        {activeTab === "costs" && (
          <div>
            <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 6 }}>Costs & Revenue — California 2026</h2>
            <p style={{ fontSize: 15, color: "#666", marginBottom: 24, lineHeight: 1.5 }}>Realistic numbers including California-specific electricity rates, demand charges, and incentive stacking.</p>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 20, marginBottom: 28 }}>
              <div style={{ padding: 20, borderRadius: 12, border: "1.5px solid #e0ddd5", background: "white", borderTop: "4px solid #0A6847" }}>
                <div className="sl" style={{ color: "#0A6847" }}>Level 2 — AC Charging</div>
                {[["Hardware (US-made)","$800–$5,000"],["Hardware (Chinese+tariff)","$400–$2,800"],["Installation","$1,500–$8,000"],["Total per port","$3,000–$12,000"],["Revenue","~$0.25/kWh"],["Speed","7–19.2 kW"]].map(([k,v])=>(
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "1px solid #f0ede5" }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: "#888" }}>{k}</span>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 600 }}>{v}</span>
                  </div>
                ))}
              </div>
              <div style={{ padding: 20, borderRadius: 12, border: "1.5px solid #e0ddd5", background: "white", borderTop: "4px solid #C40C0C" }}>
                <div className="sl" style={{ color: "#C40C0C" }}>Level 3 — DC Fast Charging</div>
                {[["Hardware (US-made)","$25,000–$80,000"],["Hardware (Chinese+tariff)","$15,000–$55,000"],["Installation + transformer","$30,000–$120,000"],["Total per site (4 ports)","$200,000–$400,000+"],["Revenue","~$0.45–$0.55/kWh"],["Speed","50–350 kW"]].map(([k,v])=>(
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: "1px solid #f0ede5" }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: "#888" }}>{k}</span>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 600 }}>{v}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="warn-box" style={{ marginBottom: 24 }}>
              <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, color: "#92400E", marginBottom: 6 }}>⚡ California Demand Charges — The Hidden Cost</h3>
              <p style={{ fontSize: 13, color: "#78350F", lineHeight: 1.55 }}>
                California utilities charge $2K–$10K/month in demand charges for DCFC stations, based on peak power draw. This can eat 30-50% of your DCFC revenue. Mitigate with: battery storage systems, solar canopies, utility EV rate programs (SCE TOU-EV-9, PG&E BEV-2), and smart load management. Consider FreeWire's battery-integrated chargers that don't require 480V service.
              </p>
            </div>

            <div className="sl">💰 Incentive Stacking Example (4-Port DCFC in California)</div>
            <div style={{ padding: 20, borderRadius: 12, border: "1.5px solid #e0ddd5", background: "white" }}>
              {[
                ["Total project cost (US-made, NEVI eligible)", "$280,000", ""],
                ["NEVI funding (80% of eligible costs)", "−$224,000", "#0A6847"],
                ["Federal 30C tax credit (30%, up to $100K)", "−$16,800", "#0A6847"],
                ["CALeVIP 2.0 (if additional funding available)", "−$0–$100K", "#1679AB"],
                ["Utility make-ready rebate", "−$5,000–$20,000", "#1679AB"],
                ["Your out-of-pocket", "$19,200–$34,200", "#C40C0C"],
              ].map(([k, v, c], i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: i < 5 ? "1px solid #f0ede5" : "2px solid #1a1a1a" }}>
                  <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#555" }}>{k}</span>
                  <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, color: c || "#1a1a1a" }}>{v}</span>
                </div>
              ))}
              <p style={{ marginTop: 12, fontSize: 12, color: "#888", lineHeight: 1.5 }}>
                With proper incentive stacking, your out-of-pocket for a $280K DCFC station could be as low as $19K–$34K. Compare this to Chinese chargers at ~$180K total cost with zero incentives — the US-made + NEVI route is actually cheaper for highway sites.
              </p>
            </div>
          </div>
        )}

        {/* ============ CA INCENTIVES ============ */}
        {activeTab === "incentives" && (
          <div>
            <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 6 }}>California & Federal Incentives (2026)</h2>
            <p style={{ fontSize: 15, color: "#666", marginBottom: 24, lineHeight: 1.5 }}>All available funding sources for your EV charging business in California.</p>

            <div className="crit-box" style={{ marginBottom: 20 }}>
              <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, color: "#991B1B", marginBottom: 6 }}>🚨 DEADLINE: Federal 30C Tax Credit Expires June 30, 2026</h3>
              <p style={{ fontSize: 13, color: "#7F1D1D", lineHeight: 1.55 }}>
                The Alternative Fuel Infrastructure Tax Credit (30% of costs, up to $100K for commercial) was ended by the One Big Beautiful Act. Stations must be placed in service by June 30, 2026 to qualify. This is your most urgent action item — plan installations to meet this deadline.
              </p>
            </div>

            {[
              { title: "NEVI Formula Program — $384M for California", body: "Federal $5B program. CA allocated $384M. Covers up to 80% of eligible costs for highway corridor DCFC. MUST use Buy America compliant (US-made) chargers. 97% uptime requirement. Minimum 150kW per port, 4 ports per station. Program was frozen Feb 2025, restarted Aug 2025 after court order. Monitor status — Trump admin continues to challenge.", color: "#0A6847" },
              { title: "CALeVIP 2.0 — Golden State Priority Project", body: "State-funded via CEC. Up to $100,000 per DCFC connector or 50% of total costs. Minimum 150kW per connector. Prioritizes underserved & disadvantaged communities (DAC/LIC). Fast Charge California application window closed Jan 2026 — watch for new rounds. L2 chargers must be ENERGY STAR certified.", color: "#1679AB" },
              { title: "Federal 30C Tax Credit (EXPIRING)", body: "30% of qualified EV charging property costs. Commercial: up to $100,000 per location (with prevailing wage/apprenticeship). Residential: up to $1,000. Must be in eligible census tracts. DEADLINE: June 30, 2026. File via IRS Form 8911.", color: "#C40C0C" },
              { title: "California Utility Programs", body: "PG&E: EV Fleet program, make-ready infrastructure rebates, BEV-2 commercial rate. SCE: Charge Ready program, TOU-EV-9 rate. SDG&E: Power Your Drive program. Programs cover electrical infrastructure (panels, conduit, trenching) — often $5K-$50K per site. Check each utility for current availability.", color: "#7C00FE" },
              { title: "Local Air District Programs", body: "SCAQMD (LA area): AQIP program for commercial chargers. SJVAPCD: Charge Up! program — rebates for L2 and DCFC. BAAQMD (Bay Area): various EV infrastructure incentives. Annual caps vary ($50K-$200K per applicant). Check your local air district for current openings.", color: "#E8751A" },
              { title: "PACE Financing", body: "Property Assessed Clean Energy loans — pay for EV charger installation through property tax assessments. No upfront cost. Repayment over 15-20 years. Available for commercial properties in California. Can be combined with other incentives.", color: "#3D3B40" },
            ].map((item, i) => (
              <div key={i} style={{ marginBottom: 12, padding: 18, borderRadius: 12, background: "white", border: "1px solid #ebe8e0", borderLeft: `4px solid ${item.color}` }}>
                <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, marginBottom: 6 }}>{item.title}</h3>
                <p style={{ fontSize: 13, color: "#555", lineHeight: 1.55 }}>{item.body}</p>
              </div>
            ))}

            <div className="warn-box" style={{ marginTop: 20 }}>
              <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 700, color: "#92400E", marginBottom: 6 }}>⚠️ Important Policy Context (2026)</h3>
              <p style={{ fontSize: 13, color: "#78350F", lineHeight: 1.55 }}>
                The federal EV incentive landscape has shifted significantly. The "One Big Beautiful Act" ended multiple EV tax credits. The NEVI program faced a 6-month freeze and ongoing legal challenges. California remains the strongest state for EV charging incentives, but federal support is less certain. Prioritize state and utility programs, and act before the June 30 federal deadline. Consider consulting with an incentive specialist (Resound Energy, Qmerit) to maximize stacking.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
function USManufacturerDirectory() {
  const [cat, setCat] = useState("all");
  const [expanded, setExpanded] = useState(null);

  const filtered = cat === "all" ? ussuppliers : ussuppliers.filter((s) => s.cat === cat);

  return (
    <div style={{ fontFamily: "'Newsreader','Georgia',serif", background: "#FAFAF7", minHeight: "100vh", color: "#1a1a1a" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,400;6..72,600;6..72,700&family=DM+Sans:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .card{padding:16px 20px;border-radius:10px;background:white;border:1px solid #ebe8e0;transition:all .2s;cursor:pointer;margin-bottom:10px}
        .card:hover{border-color:#bbb;box-shadow:0 4px 16px rgba(0,0,0,.06)}
        .card.feat{border:2px solid #1a4f8b;box-shadow:0 4px 20px rgba(26,79,139,.1)}
        .card.open{box-shadow:0 6px 24px rgba(0,0,0,.08)}
        .fb{cursor:pointer;padding:8px 16px;border:1.5px solid #e0ddd5;border-radius:8px;background:white;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;color:#555;transition:all .2s}
        .fb:hover{border-color:#aaa}
        .fb.ac{background:#1a2744;color:white;border-color:#1a2744}
        .fb.green{background:#0A6847;color:white;border-color:#0A6847}
        .fb.red{background:#8B0000;color:white;border-color:#8B0000}
        .nevi-badge{background:#DCFCE7;color:#166534;padding:3px 8px;border-radius:4px;font-size:10px;font-weight:700;font-family:'DM Sans',sans-serif}
        .baba-badge{background:#DBEAFE;color:#1E40AF;padding:3px 8px;border-radius:4px;font-size:10px;font-weight:700;font-family:'DM Sans',sans-serif}
        .top-badge{background:#DBEAFE;color:#1E40AF;padding:3px 10px;border-radius:4px;font-size:10px;font-weight:700;font-family:'DM Sans',sans-serif;display:inline-block;margin-bottom:6px}
        .warn-badge{background:#FEF3C7;color:#92400E;padding:3px 8px;border-radius:4px;font-size:10px;font-weight:700;font-family:'DM Sans',sans-serif}
        .sl{font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#888;margin-bottom:8px}
        .price-tag{font-family:'DM Sans',sans-serif;font-size:14px;font-weight:700;color:#1a4f8b}
      `}</style>

      {/* Header */}
      <div style={{ background: "linear-gradient(135deg,#002147 0%,#1a4f8b 50%,#003366 100%)", color: "white", padding: "32px 24px 24px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", opacity: .5 }}>Supplier Directory</span>
            <span style={{ background: "rgba(255,255,255,.15)", padding: "2px 10px", borderRadius: 4, fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>🇺🇸 MADE IN USA</span>
            <span style={{ background: "#0A6847", padding: "2px 10px", borderRadius: 4, fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>NEVI + BUY AMERICA</span>
          </div>
          <h1 style={{ fontSize: "clamp(22px,4.5vw,32px)", fontWeight: 700, lineHeight: 1.2, marginBottom: 10 }}>US EV Charger Manufacturers</h1>
          <p style={{ fontSize: 14, opacity: .75, lineHeight: 1.5, maxWidth: 640 }}>
            {ussuppliers.length} manufacturers with US factories that qualify for NEVI funding (government pays up to 80%) and Buy America compliance. For VB Charging's federally-funded highway corridor stations in California.
          </p>
          <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))", gap: 10 }}>
            {[
              ["$5 Billion", "NEVI program total"],
              ["$384 Million", "California's NEVI share"],
              ["Up to 80%", "Federal cost coverage"],
              ["55%+", "US content required"],
            ].map(([v, l], i) => (
              <div key={i} style={{ background: "rgba(255,255,255,.08)", borderRadius: 8, padding: "10px 14px" }}>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 18, fontWeight: 700 }}>{v}</div>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, opacity: .6 }}>{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: "0 auto", padding: "20px 24px 60px" }}>
        {/* Filters */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 20 }}>
          <button className={`fb ${cat === "all" ? "ac" : ""}`} onClick={() => setCat("all")}>All ({ussuppliers.length})</button>
          <button className={`fb ${cat === "DC" ? "red" : ""}`} onClick={() => setCat("DC")}>DC Fast / Level 3 ({ussuppliers.filter((s) => s.cat === "DC").length})</button>
          <button className={`fb ${cat === "L2" ? "green" : ""}`} onClick={() => setCat("L2")}>Level 2 AC ({ussuppliers.filter((s) => s.cat === "L2").length})</button>
        </div>

        {/* NEVI Explainer */}
        <div style={{ padding: 14, borderRadius: 10, background: "#EFF6FF", border: "1.5px solid #BFDBFE", marginBottom: 20 }}>
          <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#1E40AF", lineHeight: 1.55 }}>
            <strong>Why Buy American for federal sites?</strong> NEVI covers up to 80% of costs — a $280K DCFC station could cost you just ~$19K–$34K out of pocket after incentive stacking. Even though US hardware is pricier than Chinese, your actual cost is LOWER on NEVI-funded sites because the government pays the difference. Chinese chargers cannot qualify.
          </p>
        </div>

        {/* Cards */}
        {filtered.map((s, i) => {
          const isOpen = expanded === `${cat}-${i}`;
          return (
            <div key={`${cat}-${i}`} className={`card ${s.featured ? "feat" : ""} ${isOpen ? "open" : ""}`} style={{ borderLeft: `4px solid ${s.cat === "DC" ? "#8B0000" : "#0A6847"}` }}
              onClick={() => setExpanded(isOpen ? null : `${cat}-${i}`)}>
              {s.featured && <span className="top-badge">Top pick for VB Charging</span>}

              {/* Header */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 3 }}>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 16, fontWeight: 700 }}>{s.name}</span>
                    <span style={{ fontSize: 11, color: "#888", fontFamily: "'DM Sans',sans-serif" }}>{s.hq}</span>
                  </div>
                  <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 4 }}>
                    <span className="nevi-badge">NEVI Compliant</span>
                    <span className="baba-badge">Buy America</span>
                    <span style={{ background: s.cat === "DC" ? "#FEE2E2" : "#DCFCE7", color: s.cat === "DC" ? "#991B1B" : "#166534", padding: "2px 6px", borderRadius: 3, fontSize: 10, fontWeight: 700, fontFamily: "'DM Sans',sans-serif" }}>
                      {s.cat === "DC" ? "DC Fast" : "Level 2"}
                    </span>
                  </div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: "#666" }}>{s.power} · {s.connectors}</div>
                </div>
                <div style={{ textAlign: "right", flexShrink: 0 }}>
                  <div className="price-tag">{s.price}</div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 10, color: "#888" }}>US factory: {s.factory.split("(")[0].trim()}</div>
                </div>
              </div>

              {/* Expanded */}
              {isOpen && (
                <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f0ede5" }}>
                  {/* Why this supplier */}
                  <div style={{ padding: 14, background: "#FAF9F6", borderRadius: 8, marginBottom: 14 }}>
                    <div className="sl" style={{ marginBottom: 4, color: "#1a4f8b" }}>Why this supplier</div>
                    <p style={{ fontSize: 13, color: "#444", lineHeight: 1.55 }}>{s.note}</p>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                    {/* Left column */}
                    <div>
                      <div className="sl">Products & specs</div>
                      {[
                        ["Products", s.products],
                        ["Power range", s.power],
                        ["Connectors", s.connectors],
                        ["OCPP", s.ocpp],
                        ["Certifications", s.certs],
                      ].map(([k, v]) => (
                        <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", borderBottom: "1px solid #f5f3ed" }}>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#888" }}>{k}</span>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 500, textAlign: "right", maxWidth: "60%" }}>{v}</span>
                        </div>
                      ))}
                    </div>

                    {/* Right column */}
                    <div>
                      <div className="sl">Company details</div>
                      {[
                        ["US factory", s.factory],
                        ["Track record", s.installed],
                        ["Employees", s.employees],
                        ["Founded", s.founded],
                        ["Website", s.website],
                      ].map(([k, v]) => (
                        <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", borderBottom: "1px solid #f5f3ed" }}>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#888" }}>{k}</span>
                          <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 500, textAlign: "right", maxWidth: "65%" }}>{v}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Special features */}
                  <div style={{ marginTop: 12, padding: 12, background: "#F0F9FF", borderRadius: 8, border: "1px solid #BAE6FD" }}>
                    <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 700, color: "#0369A1", marginBottom: 4 }}>Key differentiator</div>
                    <p style={{ fontSize: 12, color: "#0C4A6E", lineHeight: 1.5 }}>{s.special}</p>
                  </div>
                </div>
              )}

              {!isOpen && (
                <div style={{ textAlign: "center", marginTop: 8 }}>
                  <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#bbb" }}>▼ Tap for full details</span>
                </div>
              )}
            </div>
          );
        })}

        {/* Strategy box */}
        <div style={{ marginTop: 24, padding: 20, borderRadius: 12, background: "white", border: "1.5px solid #e0ddd5" }}>
          <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 14 }}>🎯 VB Charging — Recommended US Supplier Strategy</h3>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 12 }}>
            {[
              ["#002147", "Primary DCFC", "BTC Power", "Local to LA. Buy America + NEVI. 25K+ units. Use for all federally-funded highway sites."],
              ["#8B0000", "Ultra-fast 200kW+", "SK Signet", "Texas factory. $50M invested. 10K–20K units/yr capacity. For high-power highway stations."],
              ["#0A6847", "Modular / fleet", "Kempower", "Satellite architecture — 1 power unit, many dispensers. Cost-efficient for large sites."],
              ["#1a4f8b", "Limited grid sites", "FreeWire", "Battery-integrated. No transformer needed. Kills demand charges. Local in Oakland, CA."],
              ["#555", "Level 2 sites", "Wallbox / BTC Power", "ENERGY STAR (CALeVIP eligible). Hotels, offices, multifamily destination charging."],
            ].map(([c, role, name, desc], i) => (
              <div key={i} style={{ padding: 14, borderRadius: 8, borderLeft: `4px solid ${c}`, background: "#FAF9F6" }}>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 700, color: c, marginBottom: 2 }}>{role}</div>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 4 }}>{name}</div>
                <p style={{ fontSize: 12, color: "#666", lineHeight: 1.45 }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Reminder about dual strategy */}
        <div style={{ marginTop: 16, padding: 16, borderRadius: 10, background: "#FFFBEB", border: "1.5px solid #FDE68A" }}>
          <h3 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 700, color: "#92400E", marginBottom: 6 }}>💡 Remember: Dual-source strategy</h3>
          <p style={{ fontSize: 13, color: "#78350F", lineHeight: 1.55 }}>
            <strong>NEVI-funded sites (highways):</strong> Use these US manufacturers. Government pays up to 80%. Your out-of-pocket: ~$19K–$34K for a $280K station.
            <br /><br />
            <strong>Private commercial sites (malls, hotels, offices):</strong> Use Chinese manufacturers (BENY, EN+, Autel) with vinyl branding. 20-35% cheaper, no federal restrictions. Full VB Charging brand identity.
            <br /><br />
            This dual approach maximizes both incentive capture AND profit margins across your entire network.
          </p>
        </div>
      </div>
    </div>
  );
}



function NEVIGuide() {
  const [activeSection, setActiveSection] = useState("overview");
  const [expandedItems, setExpandedItems] = useState({});

  const toggleItem = (sectionId, idx) => {
    const key = `${sectionId}-${idx}`;
    setExpandedItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const currentSection = sections.find((s) => s.id === activeSection);

  return (
    <div style={{ fontFamily: "'Newsreader','Georgia',serif", background: "#FAFAF7", minHeight: "100vh", color: "#1a1a1a" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,400;6..72,600;6..72,700&family=DM+Sans:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .nav-btn_guide{cursor:pointer;padding:10px 14px;border:1.5px solid #e0ddd5;border-radius:10px;background:white;text-align:left;transition:all .2s;width:100%;display:flex;align-items:center;gap:10px}
        .nav-btn_guide:hover{border-color:#bbb;background:#FAF9F6}
        .nav-btn_guide.active{border-color:#002147;background:#EFF6FF;box-shadow:0 2px 8px rgba(0,33,71,.1)}
        .item{padding:14px 16px;border-radius:8px;background:white;border:1px solid #ebe8e0;margin-bottom:8px;cursor:pointer;transition:all .2s}
        .item:hover{border-color:#ccc;box-shadow:0 2px 8px rgba(0,0,0,.04)}
        .item.open{border-color:#002147;box-shadow:0 4px 12px rgba(0,0,0,.06)}
        .sl{font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#888;margin-bottom:10px}
      `}</style>

      {/* Header */}
      <div style={{ background: "linear-gradient(135deg,#002147 0%,#1a4f8b 50%,#003366 100%)", color: "white", padding: "32px 24px 24px" }}>
        <div style={{ maxWidth: 940, margin: "0 auto" }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", opacity: .5 }}>Federal Funding Guide</span>
            <span style={{ background: "rgba(255,255,255,.15)", padding: "2px 10px", borderRadius: 4, fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>NEVI Program</span>
            <span style={{ background: "#0A6847", padding: "2px 10px", borderRadius: 4, fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 700 }}>California</span>
          </div>
          <h1 style={{ fontSize: "clamp(22px,4.5vw,32px)", fontWeight: 700, lineHeight: 1.2, marginBottom: 10 }}>NEVI Funding: Complete Requirements<br />& Step-by-Step Application Guide</h1>
          <p style={{ fontSize: 14, opacity: .75, lineHeight: 1.5, maxWidth: 640 }}>
            Everything VB Charging needs to know to apply for NEVI funding in California — technical standards, Buy America compliance, site requirements, the application process, and tips to win.
          </p>
          <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))", gap: 10 }}>
            {[
              ["$384M", "CA NEVI allocation"],
              ["80%", "Max federal coverage"],
              ["20%", "Your minimum match"],
              ["4 ports", "Min per station"],
              ["150kW", "Min per port"],
              ["97%", "Uptime required"],
            ].map(([v, l], i) => (
              <div key={i} style={{ background: "rgba(255,255,255,.08)", borderRadius: 8, padding: "8px 12px" }}>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 17, fontWeight: 700 }}>{v}</div>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 10, opacity: .6 }}>{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 940, margin: "0 auto", padding: "20px 24px 60px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "220px minmax(0,1fr)", gap: 24 }}>
          {/* Sidebar navigation */}
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <div className="sl">Sections</div>
            {sections.map((s) => (
              <button key={s.id} className={`nav-btn_guide ${activeSection === s.id ? "active" : ""}`} onClick={() => setActiveSection(s.id)}>
                <span style={{ fontSize: 16 }}>{s.icon}</span>
                <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 600, color: activeSection === s.id ? "#002147" : "#555" }}>{s.title}</span>
              </button>
            ))}
          </div>

          {/* Content area */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <span style={{ fontSize: 28 }}>{currentSection.icon}</span>
              <h2 style={{ fontSize: 24, fontWeight: 700 }}>{currentSection.title}</h2>
            </div>

            {currentSection.content.map((item, idx) => {
              const key = `${activeSection}-${idx}`;
              const isOpen = expandedItems[key] !== false;
              return (
                <div key={idx} className={`item ${isOpen ? "open" : ""}`} onClick={() => toggleItem(activeSection, idx)}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 700, color: "#002147", background: "#EFF6FF", width: 24, height: 24, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{idx + 1}</span>
                      <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 600 }}>{item.heading}</span>
                    </div>
                    <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: "#bbb", flexShrink: 0 }}>{isOpen ? "▲" : "▼"}</span>
                  </div>
                  {isOpen && (
                    <p style={{ marginTop: 10, marginLeft: 34, fontSize: 13, color: "#555", lineHeight: 1.65 }}>{item.text}</p>
                  )}
                </div>
              );
            })}

            {/* Bottom contextual note */}
            {activeSection === "application" && (
              <div style={{ marginTop: 16, padding: 16, borderRadius: 10, background: "#FEF2F2", border: "1.5px solid #FECACA" }}>
                <h4 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 700, color: "#991B1B", marginBottom: 6 }}>🚨 Don't miss these deadlines</h4>
                <p style={{ fontSize: 13, color: "#7F1D1D", lineHeight: 1.55 }}>
                  <strong>GFO-25-604 (Round 4, MDHD Northern/Central CA):</strong> Submission deadline April 22, 2026<br />
                  <strong>GFO-25-606 (Round 5, MDHD Southern CA — your region!):</strong> Submission deadline May 7, 2026<br />
                  <strong>Federal 30C tax credit:</strong> Stations must be placed in service by June 30, 2026<br /><br />
                  Check energy.ca.gov/solicitations regularly for new rounds (Round 6+ may open later in 2026).
                </p>
              </div>
            )}

            {activeSection === "overview" && (
              <div style={{ marginTop: 16, padding: 16, borderRadius: 10, background: "#FFFBEB", border: "1.5px solid #FDE68A" }}>
                <h4 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 700, color: "#92400E", marginBottom: 6 }}>💰 The math that matters</h4>
                <p style={{ fontSize: 13, color: "#78350F", lineHeight: 1.55 }}>
                  Example: 4-port DCFC station using BTC Power (150kW each)<br />
                  Total project cost: ~$280,000<br />
                  NEVI funding (80%): −$224,000<br />
                  Your match (20%): $56,000<br />
                  30C tax credit (30% of your match): −$16,800<br />
                  <strong>Your actual out-of-pocket: ~$39,200</strong><br /><br />
                  Compare to Chinese chargers with no incentives: ~$180,000 out of pocket. NEVI + US-made is actually 78% cheaper for you.
                </p>
              </div>
            )}

            {activeSection === "california" && (
              <div style={{ marginTop: 16, padding: 16, borderRadius: 10, background: "#EFF6FF", border: "1.5px solid #BFDBFE" }}>
                <h4 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 700, color: "#1E40AF", marginBottom: 6 }}>📊 California NEVI funding breakdown</h4>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: "#1E3A5F", lineHeight: 1.6 }}>
                  {[
                    ["Round 1", "Oct 2023", "$30.1M", "Light-Duty", "Awarded"],
                    ["Round 2", "Dec 2024", "$33.4M", "Light-Duty", "In progress"],
                    ["Round 3", "Dec 2025", "$79.0M", "Light-Duty", "Active"],
                    ["Round 4", "Jan 2026", "$69.5M", "MDHD (N/Central CA)", "Deadline: Apr 22"],
                    ["Round 5", "Feb 2026", "$79.0M", "MDHD (Southern CA)", "Deadline: May 7"],
                    ["Round 6", "2026", "TBD", "Light-Duty AFCs", "Check CEC"],
                  ].map(([r, d, f, focus, status], i) => (
                    <div key={i} style={{ display: "flex", gap: 8, padding: "4px 0", borderBottom: i < 5 ? "1px solid #DBEAFE" : "none", fontSize: 12 }}>
                      <span style={{ width: 60, fontWeight: 600 }}>{r}</span>
                      <span style={{ width: 70, color: "#6B7280" }}>{d}</span>
                      <span style={{ width: 60, fontWeight: 600 }}>{f}</span>
                      <span style={{ flex: 1, color: "#6B7280" }}>{focus}</span>
                      <span style={{ fontWeight: 500, color: status.includes("Deadline") ? "#991B1B" : "#166534" }}>{status}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeSection === "resources" && (
              <div style={{ marginTop: 16, padding: 16, borderRadius: 10, background: "#F0FDF4", border: "1.5px solid #BBF7D0" }}>
                <h4 style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 700, color: "#166534", marginBottom: 6 }}>✅ Your first 3 actions today</h4>
                <p style={{ fontSize: 13, color: "#14532D", lineHeight: 1.65 }}>
                  1. <strong>Create your ECAMS account</strong> at energy.ca.gov — do this immediately, don't wait for a solicitation<br />
                  2. <strong>Open the CEC NEVI interactive map</strong> and identify 5–10 potential station sites along Southern California corridors within 1 mile of highway exits<br />
                  3. <strong>Contact your utility</strong> (SCE for LA area) about EV commercial interconnection — this is the longest lead time item (3–6 months) and must start before you apply
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}





// ==========================================
// PASSWORD GATE + APP SHELL
// ==========================================
const PASSWORD = "ev2026";

function LoginScreen({ onLogin }) {
  const [pw, setPw] = useState("");
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = () => {
    if (pw === PASSWORD) {
      sessionStorage.setItem("ev_auth", "1");
      onLogin();
    } else {
      setError(true);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0a1628 0%, #1a2744 40%, #0f3460 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif",
      padding: 24,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,400;6..72,600;6..72,700&family=DM+Sans:wght@400;500;600;700&display=swap');
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20%, 60% { transform: translateX(-8px); }
          40%, 80% { transform: translateX(8px); }
        }
        .login-box { animation: ${shake ? "shake 0.4s ease" : "none"}; }
        .pw-input {
          width: 90%;
          padding: 14px 16px;
          border: 2px solid ${error ? "#ef4444" : "#2a3a5c"};
          border-radius: 10px;
          background: rgba(255,255,255,0.06);
          color: white;
          font-size: 16px;
          font-family: 'DM Sans', sans-serif;
          outline: none;
          transition: border-color 0.2s;
        }
        .pw-input:focus { border-color: ${error ? "#ef4444" : "#4a8fe7"}; }
        .pw-input::placeholder { color: rgba(255,255,255,0.3); }
        .login-btn {
          width: 100%;
          padding: 14px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(135deg, #0A6847, #0d8a5e);
          color: white;
          font-size: 15px;
          font-weight: 700;
          font-family: 'DM Sans', sans-serif;
          cursor: pointer;
          transition: all 0.2s;
        }
        .login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(10,104,71,0.4); }
      `}</style>
      <div className="login-box" style={{
        width: "100%",
        maxWidth: 380,
        padding: 36,
        borderRadius: 16,
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.08)",
        backdropFilter: "blur(20px)",
        boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
      }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
        <img src="/logoanimated5.gif" alt="Logo" style={{ width: 260, height: 80, marginBottom: 12, borderRadius: 12 }} />
          <h1 style={{
            fontFamily: "'Newsreader', Georgia, serif",
            fontSize: 24,
            fontWeight: 700,
            color: "white",
            marginBottom: 6,
          }}>VB Charging Platform</h1>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", lineHeight: 1.5 }}>
            Enter password to access the dashboard
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <input
            className="pw-input"
            type="password"
            placeholder="Password"
            value={pw}
            onChange={(e) => { setPw(e.target.value); setError(false); }}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            autoFocus
          />
          {error && (
            <p style={{ fontSize: 12, color: "#ef4444", textAlign: "center", margin: "-4px 0" }}>
              Incorrect password. Please try again.
            </p>
          )}
          <button className="login-btn" onClick={handleSubmit}>
            Access Dashboard
          </button>
        </div>

        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.2)", textAlign: "center", marginTop: 20 }}>
          Protected content · Authorized access only
        </p>
      </div>
    </div>
  );
}

export default function App() {
  const [authed, setAuthed] = useState(false);
  const [page, setPage] = useState("plan");

  if (!authed) {
    return <LoginScreen onLogin={() => setAuthed(true)} />;
  }

  return (
    <div>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
        .nav-bar {
          position: sticky; top: 0; z-index: 100;
          background: #0a1628;
          border-bottom: 1px solid rgba(255,255,255,0.08);
          display: flex; align-items: center; justify-content: center;
          gap: 4px; padding: 8px 16px;
        }
        .nav-btn {
          padding: 8px 18px;
          border: 1.5px solid rgba(255,255,255,0.12);
          border-radius: 8px;
          background: transparent;
          color: rgba(255,255,255,0.5);
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; font-weight: 600;
          cursor: pointer; transition: all 0.2s;
        }
        .nav-btn:hover { color: white; border-color: rgba(255,255,255,0.25); }
        .nav-btn.active { background: #0A6847; color: white; border-color: #0A6847; }
        .nav-logout {
          position: absolute; right: 16px;
          padding: 6px 12px;
          border: 1px solid rgba(255,255,255,0.12);
          border-radius: 6px;
          background: transparent;
          color: rgba(255,255,255,0.35);
          font-family: 'DM Sans', sans-serif;
          font-size: 11px; font-weight: 600;
          cursor: pointer; transition: all 0.2s;
        }
        .nav-logout:hover { color: #ef4444; border-color: #ef4444; }
      `}</style>

      <div className="nav-bar">
        <button className={`nav-btn ${page==="plan"?"active":""}`} onClick={()=>setPage("plan")}>
          📋 Business Plan
        </button>
        <button className={`nav-btn ${page==="dir"?"active":""}`} onClick={()=>setPage("dir")}>
          🇨🇳 Supplier Directory
        </button>
        <button className={`nav-btn ${page==="ussup"?"active":""}`} onClick={()=>setPage("ussup")}>
          🇺🇸 Manufacturer Directory
        </button>
        <button className={`nav-btn ${page==="neviguide"?"active":""}`} onClick={()=>setPage("neviguide")}>
          💡 NEVI Funding Guide
        </button>
        <button className="nav-logout" onClick={()=>setAuthed(false)} style={{ position: "absolute", right: 16 }}>
          Logout
        </button>
      </div>

      {page === "plan" && <EVBusinessPlan />}
      {page === "dir" && <SupplierDirectory />}
      {page === "ussup" && <USManufacturerDirectory />}
      {page === "neviguide" && <NEVIGuide />}
    </div>
  );
}
